var _desc;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientOnboardImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    viewBox: "0 0 500 670",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Source: openclipart.org/detail/209545")), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 617.3,
    height: 401,
    style: {
      display: "none",
      fill: "rgb(0, 94, 184)",
      perspectiveOrigin: "50% 50%"
    },
    x: -118.114,
    y: 122.716
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.495676, 0, 0, 0.518286, -9.837237, 290.873627)",
    style: {}
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 219.9,
    cy: 289.2,
    r: 22.9,
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 207.3,
    cy: 316.6,
    r: 14.8,
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 172.8,
    cy: 325.2,
    r: 24.3,
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 146.3,
    cy: 338.6,
    r: 24.3,
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 107.8,
    cy: 282.5,
    r: 24.3,
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 164,
    cy: 305.1,
    r: 24.3,
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 188,
    cy: 265.6,
    r: 24.1,
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 148.9,
    cy: 271.2,
    r: 36.8,
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 112.5,
    cy: 321.3,
    r: 35.5,
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 144.7,
    cy: 309.1,
    r: 18,
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 189.7,
    cy: 305.2,
    r: 20.7,
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 54.6,
    cy: 292.9,
    r: 9.6,
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 41,
    cy: 262.7,
    r: 5.4,
    style: {
      fill: "rgb(0, 149, 214)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -87.101257, 130.133636)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M276.1,143.2c0,0-8-1.2-8.4-1.1c-0.4,0-3.6-9-3.8-9.6l0,0l-0.2-2.3c0,0,0-0.1,0-0.1l0-0.3l5.9,0.3l5.6,2.1 l0.1,1.4l0.6,6.9L276.1,143.2z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "348.7,303 348.3,309.1 345.4,311.4 343.5,308.3 343,301.8 \t\t\t\t\t",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M343.5,308.3c0,0-0.2,6.3,0,7.1c0.1,0.3,3-0.4,5.3,0.9c1,0.6,1.6,1.8,2.5,2c1.3,0.2,4.4,0.2,4.5,0.1 c0-0.1,0.7-0.9-2.1-3.1c-1.2-0.9-5.5-6.2-5.5-6.2s-2.7-0.9-2.7-0.9C345.6,308.2,343.5,308.3,343.5,308.3z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M343.5,315.4c0,0,3.6,0.7,3.6,0.7c0,0-0.1,2.5-0.1,2.5l-3.7-0.2L343.5,315.4z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M346,315.8c0,0,1.8,0.4,2.4,0.7c0.6,0.3,2.1,2,2.9,2.2c0.5,0.1,0.9,0.1,1.4,0.1c0.6,0,1.3,0,1.9,0.1 c0.2,0,1.1,0.1,1.3,0c0.1-0.1,0.1-0.6-0.1-0.6c-0.3,0-4.1-0.1-4.5-0.4c-0.3-0.3-1.9-1.8-2.6-2.1c-0.7-0.2-5.3-1-5.3-1l-0.1,3.3 l2.8-1.4L346,315.8z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M347.2,315.7c0,0-0.5-1.6-1.3-2.7c-0.9-1.2-2.5-1.8-2.5-1.8s-0.1,2-0.1,2.8s0.3,1.9,0.3,1.9L347.2,315.7z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "343.4,311.1 348.3,309.1 349,309.9 344.4,312 \t\t\t\t\t",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "351.7,318.2 354.1,315.5 354.8,316.1 353,318.3 \t\t\t\t\t",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M315.3,220.4c0,0,14.4,6.5,20.1,10.4c9.9,6.8,11.3,20.9,13.7,28.6c2.4,7.6-0.6,46.1-0.6,46.1 s-16.5,0.6-17.8-0.2c-1.3-0.9-0.9-3.4,0.3-5.6c1.2-2.2-0.7-2.7-0.3-7.8c0.4-5.1,2.7-3.9,0.8-8.5c-1.9-4.7-10.3-33.8-13.5-36.1 c-3.2-2.4-27.1-14.1-25.9-16.3c1.1-2.2,6-8.8,7.1-8.6C300.2,222.4,315.3,220.4,315.3,220.4z",
    style: {
      fill: "rgb(30, 23, 33)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "456.6,252.7 454.5,261.9 451.9,264.3 449.8,261.4 450.6,251.7 \t\t\t\t\t",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M449.8,261.4l-0.4,4.6l0,0.6l-0.1,0.9l8.5,1l3,0.3c0,0,0.1-0.3,0.1-0.8c0-0.2,0-0.4,0-0.6 c0-0.4-0.1-0.8-0.2-1.1c-0.2-0.4-1.6-1.4-3.1-2.4c-0.1-0.1-0.2-0.2-0.4-0.2c0,0-0.1-0.1-0.1-0.1l0,0 c-0.1-0.1-0.2-0.2-0.4-0.2c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.1-0.3-0.2-0.5-0.3c0,0,0,0,0,0c-0.2-0.1-0.3-0.2-0.5-0.3 c-0.6-0.4-0.9-0.6-0.9-0.6l-2.7-0.3L449.8,261.4z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M449.8,261.4l-0.4,4.6l0,0.6l-0.1,0.9l8.5,1l0,0c0.1-1.2-1.3-2.4-2.1-3c-1.5-1.1-3.4-2.1-4-3.9 L449.8,261.4z",
    style: {
      fill: "rgb(255, 240, 227)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "479,243.5 477.7,252.9 475.3,255.4 473,252.7 472.9,243 \t\t\t\t\t",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M473,252.7l0,4.6l0,0.6l0,0.9l8.6,0.3l3.1,0.1c0,0,0-0.3,0-0.8c0-0.2,0-0.4,0-0.6c0-0.4-0.1-0.8-0.3-1 c-0.2-0.4-1.8-1.3-3.3-2.2c-0.1-0.1-0.3-0.1-0.4-0.2c0,0-0.1-0.1-0.1-0.1l0,0c-0.1-0.1-0.3-0.1-0.4-0.2 c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.1-0.4-0.2-0.5-0.3c0,0,0,0,0,0c-0.2-0.1-0.3-0.2-0.5-0.3c-0.6-0.3-1-0.5-1-0.5l-2.7-0.1 L473,252.7z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M473,252.7l0,4.6l0,0.6l0,0.9l8.6,0.3l0,0c0-1.2-1.5-2.2-2.4-2.8c-1.5-1-3.6-1.8-4.3-3.5L473,252.7z",
    style: {
      fill: "rgb(255, 240, 227)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M221.2,181.3c-0.1,0-0.2,0-0.3-0.1c-0.5-0.1-1.1-0.2-1.7-0.4c-0.2-0.1-0.4-0.1-0.7-0.2 c-0.7-0.2-1.7-0.7-3.1-1.4c-8.3-4.2-27.1-15.5-27.1-15.5l2.7-3.1c0,0,15.2,4.1,24.5,7.1c2.4,0.8,4.4,1.4,5.6,1.9 c0.9,0.4,1.7,0.8,2.5,1.3c0.8,0.5,1.5,1.2,2,1.8C229.4,176.8,227.9,182.4,221.2,181.3z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.2,181.3c-0.1,0-0.2,0-0.3-0.1c-0.5-0.1-1.1-0.2-1.7-0.4c-0.2-0.1-0.4-0.1-0.7-0.2 c-0.7-0.2-1.7-0.7-3.1-1.4c0.1-1.6,0.2-3.6-0.2-5.5c-0.7-3.4,0.3-6.1,0.3-6.1s5,8.5,5.5,11.8 C221.2,180.2,221.3,180.9,221.2,181.3z",
    style: {
      fill: "rgb(242, 128, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M189.7,158.3c-0.5-0.5-1.2-0.8-1.7-1.3c-0.3-0.2-1.3-1-1.6-0.5c-0.1,0.1-0.1,0.2,0,0.3 c0.1,0.3,0.6,0.6,0.7,0.7c0.2,0.2,0.7,0.6,0.7,0.9c0,0.1-0.8-0.2-0.8-0.2c-0.4-0.2-0.7-0.3-1.1-0.5c-0.7-0.3-1.4-0.7-2.1-1 c-0.3-0.1-2-0.9-2.2-0.5c-0.1,0.3,1,1.1,1.3,1.2c1.3,0.7,2.1,1.5,2.2,1.5c-0.2-0.1-1.9-0.8-2.8-1.2c-0.5-0.2-1.6-0.7-1.7-0.3 c-0.1,0.4,1.1,1,1.4,1.2c0.8,0.4,2.4,1.3,2.6,1.3c-0.1,0-1.1-0.3-2-0.6c-0.4-0.1-0.8-0.2-1.1-0.3c-0.3-0.1-0.8-0.2-0.9,0.2 c0,0.2,0.2,0.4,0.4,0.5c0.2,0.1,0.4,0.2,0.6,0.3c0.4,0.2,0.8,0.4,1.2,0.5c0.1,0,0.2,0.1,0.3,0.1c-0.1,0-1.1-0.2-1.4-0.1 c-0.2,0.1-0.3,0.3-0.1,0.5c0.2,0.2,5.3,2,5.9,2.2c0.4,0.2,0.7,0.3,1,0.3c0.1,0,0.3,0,0.4,0c0,0,0.1,0,0.1,0 c0.2-0.1,0.4-0.2,0.7-0.4c0.5-0.6,1.9-2.5,1.9-2.5s0-0.1-0.1-0.2C191.1,160.1,190.3,158.9,189.7,158.3z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M275.1,134c-0.6,7-6.5,7-9.6,2.2c-0.5-0.7-0.9-1.5-1.2-2.4c-0.3-0.8-0.5-1.7-0.6-2.7 c-0.5-4.7-0.6-19.6-0.6-27c0-0.1,0-0.2,0-0.4c0-0.6,0-1.1,0-1.6c0-0.1,0-0.3,0-0.4c0-1.2,0-2,0-2l3.8-1.8c0,0,0.4,1.4,1,3.6 c0,0.1,0.1,0.2,0.1,0.4c0.1,0.2,0.1,0.4,0.2,0.6c0,0.1,0.1,0.3,0.1,0.4c2.3,8.4,6.6,24.8,6.8,28.6c0,0.2,0,0.5,0,0.7 C275.2,132.8,275.2,133.4,275.1,134z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M275.8,140.5c-0.9-0.4-2-0.9-3.2-1.5c-3.6-1.8-7.7-3.9-7.7-3.9l-0.6-1.5l-0.5-1.2l0,0c0,0,0.1,0,0.2,0.1 c0.7,0.2,3.7,1.1,7.1,1.2c1.6,0,3,0,4,0c0,0,0.1,0,0.1,0L275.8,140.5z",
    style: {
      fill: "rgb(242, 128, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M263.1,99.9c0.1,0.1,0.1,0.2,0.1,0.2s2.2-0.7,2.9-1.1c0.3-0.2,0.5-0.3,0.6-0.5c0,0,0,0,0-0.1 c0.1-0.1,0.1-0.4,0.1-0.4s0-0.6-0.1-1.1c-0.1-0.6-0.4-6-0.6-6.3c-0.1-0.2-0.4-0.2-0.5-0.1c-0.2,0.3-0.2,1.3-0.2,1.4 c0-0.1,0-0.2,0-0.3c0-0.4-0.1-0.9-0.1-1.3c0-0.2-0.1-0.5-0.2-0.7c-0.1-0.2-0.1-0.5-0.4-0.5c-0.4-0.1-0.4,0.5-0.4,0.8 c0,0.4,0,0.8,0,1.2c0,0.9,0.1,1.9,0.1,2.1c0-0.2-0.4-2-0.6-2.8c-0.1-0.4-0.4-1.7-0.8-1.7c-0.4,0-0.3,1.2-0.2,1.7 c0.1,0.9,0.4,2.8,0.4,3c-0.1-0.1-0.5-1.1-0.9-2.6c-0.1-0.3-0.5-1.6-0.9-1.6c-0.5,0.1-0.2,2-0.1,2.3c0.1,0.8,0.3,1.5,0.4,2.3 c0.1,0.4,0.1,0.8,0.2,1.2c0,0,0.1,0.9,0,0.8c-0.3-0.1-0.5-0.7-0.7-0.9c-0.1-0.2-0.2-0.7-0.5-0.9c-0.1-0.1-0.2-0.1-0.3,0 c-0.6,0.2-0.1,1.3,0,1.7c0.3,0.7,0.5,1.3,0.7,2C261.8,98.5,262.8,99.6,263.1,99.9z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M250.6,146.3L250.6,146.3c0,0-0.4,3.9-0.7,5.6c-0.2,1.6-0.7,3.1-1.4,4.6c-0.2,0.4-0.4,0.8-0.6,1.2 c-0.1,0.2-0.1,0.5-0.1,1c0,1.7,0.4,4.8,0.4,4.8s0,0,0,0c0,0,0,0-0.1,0c-0.3-0.1-1.1-0.6-2.1-1c-0.3-0.1-0.6-0.3-1-0.4 c-1-0.4-2-0.7-2.8-0.6c-1,0.1-2,0-2.9-0.4c-2-0.7-3.7-2.3-4.8-4.3c-0.6-1.1-1-2.3-1.1-3.5c-0.3-2.6,0.5-5,2-7 c1.4-1.8,3.3-3.2,5.5-3.9c2.5-0.8,5.2-0.4,7.3,1.2C248.7,144,250.7,145.5,250.6,146.3z",
    style: {
      fill: "rgb(82, 40, 28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M244.9,162c0-0.1,0-0.2,0-0.2c0-0.1-0.1-0.2-0.1-0.2c-0.2-0.5-0.5-0.7-0.9-0.8c-0.2,0-0.3-0.1-0.5-0.1 c-0.1-0.1-0.1-0.1-0.2-0.1c-1.3,0-2.7,0.1-3.9,0.5c-0.8,0.3-1.6,0.7-2.3,1.3c-1.8,1.7-1.4,4.4-3.9,5.8 c-2.1,1.2-4.1,1.5-5.8,3.3c-0.5,0.5-1.1,1.1-1.6,1.6c-1.1,1.1-2,2.2-2.7,3.7c-0.1,0.1,0,0.4,0.1,0.4c2,1,4.1,1.8,6.2,2.9 c1,0.5,2.9,2.2,4.2,1.8c1-0.3,1.3-1.8,1.7-2.6c0.5-0.9,0.9-1.9,1.4-2.7c0.4-0.6,0.8-1,1.3-1.4c0.3-0.2,0.6-0.5,1-0.7 c1.3-1,1.8-2.1,2.3-3.6c0.7-2,1.6-3.9,2.8-5.6C244.6,164.3,245.1,163,244.9,162z",
    style: {
      fill: "rgb(122, 80, 75)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M249.9,159c-0.1-0.2-0.1-0.4-0.2-0.6c-0.3-0.7-0.6-1.4-1.1-1.9c-0.5-0.6-1.2-1-2-1.1 c-1.1-0.2-1.7,0.1-2.5,0.8c-0.2,0.2-0.4,0.3-0.6,0.4c-1.1,0.6-2.3,0.2-3.5,0.2c-0.2,0-0.5,0-0.7,0.1c0,0-0.1,0-0.1,0 c0,0,0,0,0,0c-0.3,0.1-0.6,0.3-0.9,0.4c-0.7,0.3-1.4,0.6-2.2,0.4c-0.3-0.1-0.6-0.5-0.9-0.6c-0.2-0.1-0.3-0.2-0.5-0.3 c1,2,2.7,3.6,4.8,4.3c-0.8,0.3-1.6,0.7-2.3,1.3c-1.8,1.7-1.4,4.4-3.9,5.8c-2.1,1.2-4.1,1.5-5.8,3.3c-0.5,0.5-1.1,1.1-1.6,1.6 c0.4,0.9,1,1.8,2,2.2c2.2,1.1,5.1,1.2,7.5,0.7c0.9-0.2,1.9-0.5,2.8-0.9c0.3-0.2,0.6-0.5,1-0.7c1.3-1,1.8-2.1,2.3-3.6 c0.7-2,1.6-3.9,2.8-5.6c0.6-0.8,1-2,0.9-3.1c0.3,0.1,0.7,0.3,1,0.4c0.7,1.2,1.4,2.6,2.1,3.9c0.1-0.2,0.3-0.4,0.4-0.6 c0.6-1,1.1-2.1,1.4-3.2C250.1,161.3,250.2,160.1,249.9,159z",
    style: {
      fill: "rgb(82, 40, 28)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256.8,154.6c-0.2-2.9-3.8-6.3-6.2-8.3l0,0c-0.3-0.2-0.6-0.5-0.8-0.7c-0.4-0.3-0.9-0.6-1.3-0.9 c-0.9-0.5-1.8-0.9-2.7-1.1c-0.3-0.1-0.6-0.1-0.8-0.1c-1.3-0.1-2.5,0.3-3.7,1.3c-2.9,2.4-3.3,6.1-3.3,9.6 c0,0.1,0.1,0.2,0.2,0.2c0.6,0.6,1.2,1.3,1.8,1.9l0,0c0.1,0.1,0.1,0.1,0.2,0.2c1,1.1,2.1,2.2,3.2,3.2 c0.3,0.2,0.6,0.5,0.9,0.7c0.5,0.4,1,0.8,1.5,1.1c0.1,0.1,0.2,0.1,0.2,0.2c1,0.7,1.9,1.3,2.2,1.5c0,0,0,0,0.1,0c0,0,0,0,0,0 s0.2-0.1,0.6-0.3c0.3-0.2,0.7-0.4,1.1-0.7c0.6-0.4,1.3-0.8,2-1.3c0.2-0.2,0.4-0.3,0.7-0.5c0.8-0.6,1.5-1.2,2.2-1.9 C256,157.4,256.9,156,256.8,154.6z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256.2,160.9l-1.5-2.3l0,0l-0.7-1l-1.9,0.3l-2.5,0.4l-1.4,0.2l-0.6,0.1l-0.4,0.1l-1.9,0.3l0,0 l-1.3,0.2c0,0,0.3,0.5,0.7,1.3c0.2,0.3,0.4,0.7,0.6,1.1c0.1,0.2,0.2,0.3,0.2,0.4c0,0,0,0,0,0c0,0.1,0.1,0.1,0.1,0.2 c0.7,1.2,1.4,2.6,2.1,3.9c0.1,0.3,0.3,0.6,0.4,0.8c0.2,0.5,0.5,0.9,0.6,1.3l0,0c0.4,1,0.8,2.1,2.2,2.1c1.4,0,2.8-1.2,3.8-2 c1.2-1,2.3-2.2,3.6-3.1c0.1,0,0.2-0.1,0.2-0.1c0,0,0.2-0.2,0.2-0.2L256.2,160.9z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M254.7,158.6l1.5,2.3c-0.1,0-0.1,0.1-0.2,0.1c-0.4,0.2-0.5-0.2-1.3-0.1c-0.9,0-0.6,0-1.2-0.3 c-0.6-0.3-1.3,0.2-2-0.1c-0.7-0.3-0.3-0.7-0.2-0.8c0.1-0.1,0.7-0.1,1.6-0.3C253.7,159.2,254.7,158.6,254.7,158.6z",
    style: {
      fill: "rgb(242, 128, 87)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M245.8,162.2c0,0-0.9-0.3-1.1-0.6c-1.3-1.6-3.1-2.7-4.7-4c-0.3-0.2-0.6-0.5-0.9-0.7 c-0.4-0.3-0.7-0.7-1.1-1c-1.3-1.5-1.2-3.3-0.7-5.1c0.6-2.3,1.7-4.6,3.3-6.4c1.1-1.3,2.2-1.9,3.7-1.5c0,0,0-0.1,0-0.1 c0.1-0.5,0.8-0.3,0.7,0.2c-0.2,1.7-1.4,2.8-2.5,4c-1.1,1.3-1,2.6-0.4,4c0.4,0.9,0.9,1.8,1.3,2.6c-0.7,0.7-0.8,1.7-0.3,2.7 c0.1,0.1,0.1,0.2,0.2,0.3c0.4,0.6,1.1,0.9,1.8,1.1C245.5,158.8,245.8,162.2,245.8,162.2z",
    style: {
      fill: "rgb(82, 40, 28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M245.2,157.6c-0.7-0.2-1.3-0.5-1.8-1.1c-1.4,0.7-2.7,0-4.2,0.3c0,0-0.1,0-0.1,0 c0.3,0.3,0.6,0.5,0.9,0.7c1.6,1.3,3.4,2.4,4.7,4c0.2,0.3,1.1,0.6,1.1,0.6S245.5,158.8,245.2,157.6z",
    style: {
      fill: "rgb(92, 55, 50)"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M347.4,103.1c0,0-0.7-2.5-3.2-3.9c-2.1-1.1-5.8-1.4-8.6,0.8c-3.4,2.6-4.8,7.9-2.7,11.4 c1,1.7,5.9,7.2,5.9,7.2s3.7-2.1,4.6-3.3c1.4-1.8,2.3-3.9,2.7-6.2C346.5,106.4,347.4,103.1,347.4,103.1z",
    style: {
      fill: "rgb(30, 23, 33)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M341.5,101.5c-3.5,1.2-5.3,4.4-6.6,7.7c0,0.1,0,0.2,0.1,0.3c0.9,2.3,1.8,4.5,2.9,6.7c1,2,3.9,4.2,4,4.2 c3.5,0.1,9.3-0.3,10.5-4.1c0.9-3.1-1.7-8.4-3.2-10.9C347.4,102.5,344.9,100.3,341.5,101.5z",
    style: {
      fill: "rgb(150, 73, 57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M338.8,115.3c0,0,0.2,7.3-0.1,10.3c-0.1,1.1-0.3,2.2,0.9,2.9c1.2,0.7,3,0.3,4.3,0c1.5-0.3,3-0.8,4.6-1 c0.1,0,0.2,0,0.2,0c0,0,0.2-0.1,0.2-0.1l-0.5-5l-0.2-2.7l-0.1-1.2L338.8,115.3z",
    style: {
      fill: "rgb(150, 73, 57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M348.2,119.7l0.2,2.7c-0.1,0-0.1,0-0.2,0c-0.5,0-0.3-0.4-1.1-0.8c-0.8-0.4-0.6-0.3-0.9-0.8 c-0.4-0.5-1.2-0.4-1.7-1.1c-0.5-0.6,0.1-0.7,0.2-0.7c0.1,0,0.7,0.3,1.5,0.5C347.1,119.7,348.2,119.7,348.2,119.7z",
    style: {
      fill: "rgb(120, 60, 48)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M337.5,112.4c-0.2-0.6-0.1-1.1,0.4-1.5c0.5-0.4,1.4-0.1,1.3-1c-1.5-2.5,0-4.7,2.1-6.2 c0.9-0.7,2.4-1.6,3.5-1.8c1-0.2,2.6,1.3,2.6,1.3s-1.6-3.3-2.6-3.3c-2.5,0-5.6,2.4-7.4,4.1c-1.1,1.1-2.4,2.5-2.8,4.1 c-0.1,0.5-0.2,1.1-0.1,1.6c0.2,1.4,0.9,2.7,1.5,4c0.4,0.8,1.4,2.4,2.1,3.6c0.4,0.7,0.8,1.2,0.8,1.2s0.1-0.3,0.2-0.7 c0.2-0.8,0.4-2.2,0.2-3C338.5,114,337.8,113.3,337.5,112.4z",
    style: {
      fill: "rgb(30, 23, 33)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350,111.7c0,0,0.1,0.3,0.2,0.5c-0.5,0.4-1.3,0.7-1.8,0.8c-0.1,0-0.3,0.1-0.5,0.2 c-0.1-0.3-0.2-0.5-0.2-0.5",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "373.7,293.3 372.4,299.4 369.2,301.3 367.6,297.9 368.1,291.3 \t\t\t\t\t",
    style: {
      fill: "rgb(150, 73, 57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M377.7,308.1l-11.9-3.8l0.2-0.9l0-0.1l0.2-0.6l1.4-5.2l4.7,2c0,0,0.4,0.4,1,1c0.1,0.1,0.2,0.2,0.2,0.2 c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0.2,0.2,0.3,0.3,0.5,0.5c0.1,0.1,0.2,0.2,0.2,0.2l0,0 c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0.3,0.3,0.5,0.5,0.8,0.8c1,1,1.8,2,1.9,2.4c0.1,0.3,0.1,0.8,0,1.2 c0,0.2-0.1,0.4-0.1,0.6C377.8,307.7,377.7,308.1,377.7,308.1z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377.7,308.1l-11.9-3.8l0.2-0.9l8.5,2.8c0,0,0.3-0.6,0.7-1.5c0.2-0.5,0.6-1.1,0.9-1.5c1,1,1.8,2,1.9,2.4 c0.1,0.3,0.1,0.8,0,1.2c0,0.2-0.1,0.4-0.1,0.6C377.8,307.7,377.7,308.1,377.7,308.1z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "429.4,265 432.2,270.6 431,274.1 427.6,272.5 423.7,267 \t\t\t\t\t",
    style: {
      fill: "rgb(150, 73, 57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M441.9,273.9l-11.6,4.6l-0.4-0.8l0-0.1l-0.3-0.6l-2.3-4.9l4.9-1.5c0,0,0.6,0,1.4,0.1c0.1,0,0.2,0,0.3,0 c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.4,0c0.2,0,0.4,0,0.7,0.1c0.1,0,0.2,0,0.3,0l0,0c0.1,0,0.2,0,0.3,0c0.1,0,0.3,0,0.4,0 c0.4,0,0.8,0.1,1.1,0.1c1.4,0.2,2.7,0.4,3,0.6c0.3,0.2,0.6,0.5,0.8,0.9c0.1,0.2,0.2,0.4,0.3,0.5 C441.7,273.5,441.9,273.9,441.9,273.9z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.9,273.9l-11.6,4.6l-0.4-0.8l8.3-3.3c0,0-0.2-0.7-0.4-1.6c-0.1-0.5-0.3-1.2-0.3-1.7 c1.4,0.2,2.7,0.4,3,0.6c0.3,0.2,0.6,0.5,0.8,0.9c0.1,0.2,0.2,0.4,0.3,0.5C441.7,273.5,441.9,273.9,441.9,273.9z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M409.6,198.1c0.1-0.7-0.5-1.8-0.5-1.8s0.6,0.7,0.9,1.1c0.2,0.2,0.8,1,1,0.5c0.1-0.3-0.7-2.1-1-2.7 c-0.3-0.6-0.9-1.9-0.9-1.9s1.9,2.9,2.5,3.3c0.2,0.1,0.4,0,0.4-0.2c0-0.5-0.5-1.4-1-2.1c-0.7-1.1-1.4-2.1-2.3-3.1 c-0.7-0.8-4.9-4.1-4.9-4.1s-1.8,2.5-2.6,3.7c-0.1,0.1,2.4,2.9,3.7,4.2c0.8,0.8,2.4,2.6,2.7,2.8c0.1,0.1,0.3,0,0.4-0.1 c0.1-0.2,0-0.4,0-0.6c0,0,0.8,1.2,1.3,1.4C409.4,198.3,409.6,198.3,409.6,198.1z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M405.1,185.5c0,0-17.8-16.7-22.4-20.6c-7.4-6.3-16.5-0.7-8.2,7.1c3.5,3.3,28.8,17.6,28.8,17.6L405.1,185.5 z",
    style: {
      fill: "rgb(150, 73, 57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M364.3,179.9c0,0,11.3,7.2,20.2,15.4c8.9,8.2,24.6,30.1,27,33.8c2.5,3.7,19,38.2,19,38.2l-14.6,4.8 c0,0-6.3-9.2-8-11.1c-1.7-2-5.5-2.3-6-6.5c-0.5-4.3-4-1.7-8.1-7.1c-4.1-5.4-17.7-20.6-24-25.8c-6.3-5.2-26.8-21.1-28.1-25.7 c-1.3-4.5-2.6-11.1,1.9-12.7C348,181.5,364.3,179.9,364.3,179.9z",
    style: {
      fill: "rgb(20, 18, 40)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M364.5,201.7c0,0,1.3-2.5,1.9-5.4c0.7-2.9,0.4-2.4,0.2-5.3s2.7-7.7,2.7-7.7s-11.5-9.2-12.1-8.4 c-0.5,0.8-1,14.9-0.8,15.8C356.8,191.6,364.5,201.7,364.5,201.7z",
    style: {
      fill: "rgb(34, 29, 60)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M353.5,124.9c0,0,9.7,1.6,16.2,14.5c6.4,12.9,17.2,26.5,19,29.5c1.8,3,10.8,11.3,10.8,11.3 s-9.6,8.9-10.6,8.8c-1.1-0.2-2.6-3.6-4.2-4.3c-1.6-0.7-0.5,0.2-4.9-2.3c-4.4-2.5-6.2-2.5-8-5c-1.8-2.5-3.6-0.6-6.4-6.7 S353.5,124.9,353.5,124.9z",
    style: {
      fill: "rgb(85, 150, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M458.2,123.4l-7.5-9.7c0,0-2.8,4.9-2.9,5.7c-0.1,0.7-0.6,2.7,1.6,4.4s5.3,3.1,6.6,2.3 C457.4,125.2,458.2,123.4,458.2,123.4z",
    style: {
      fill: "rgb(242, 128, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M431.6,97.4c0,0,6.8,0.7,11.7,6.3c3.7,4.2,8.9,11.1,8.9,11.1l-9.4,0.8c0,0-3-6.3-3.1-7.7 C439.7,106.4,431.6,97.4,431.6,97.4z",
    style: {
      fill: "rgb(26, 196, 111)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "317,310.9 314.3,316.4 310.8,317.5 310.1,313.9 312.1,307.7 \t\t\t\t\t",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M310.1,313.9c0,0-2.5,5.8-2.6,6.6c0,0.3,3,0.7,4.6,2.8c0.7,0.9,0.8,2.3,1.6,2.8c1.1,0.7,4,1.9,4.1,1.8 c0.1-0.1,1-0.6-0.8-3.7c-0.7-1.2-2.8-7.8-2.8-7.8s-2.2-1.8-2.2-1.8C312.2,314.6,310.1,313.9,310.1,313.9z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M307.6,320.5c0,0,3.1,2,3.1,2c0,0-1,2.2-1,2.2l-3.3-1.5L307.6,320.5z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M309.7,321.9c0,0,1.5,1,2,1.5c0.5,0.5,1.2,2.7,1.8,3.1c0.4,0.3,0.8,0.4,1.3,0.6c0.6,0.3,1.2,0.5,1.7,0.8 c0.2,0.1,1,0.5,1.2,0.5c0.2-0.1,0.3-0.5,0.1-0.6c-0.3-0.1-3.8-1.7-4-2c-0.2-0.4-1.1-2.4-1.6-2.9c-0.6-0.5-4.6-2.9-4.6-2.9 l-1.3,3l3.1-0.2L309.7,321.9z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M310.9,322.1c0,0,0.2-1.6-0.2-3c-0.4-1.4-1.6-2.6-1.6-2.6s-0.9,1.8-1.2,2.6c-0.3,0.8-0.5,1.8-0.5,1.8 L310.9,322.1z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "309,316.5 314.3,316.4 314.6,317.4 309.6,317.7 \t\t\t\t\t",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "314.1,326.2 317.3,324.6 317.7,325.4 315.3,326.7 \t\t\t\t\t",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M478.4,247.6c0,0-2.4,0.4-5.4,0.8c-0.1,0-0.2,0-0.4,0.1c-2.3,0.3-4.9,0.7-6.9,1c-0.1,0-0.2,0-0.4,0.1 c-2.1,0.3-3.5,0.5-3.5,0.5c-0.2-2.1-0.3-4.2-0.2-6.3c0.1-2.1,1.3-3.9,1.4-6c0-2.1-0.9-4.4-1.3-6.4c-1.6-7.8-4.2-12.5-6.9-19.6 c-2.7-7.1-10.5-21.5-13-23.3c-2.5-1.8-19.2-19.8-18.3-23.7c0.9-3.8,3.7-11.9,3.7-11.9l13.1-2.4c0,0-1,5.3,6.1,12 c4.3,4.1,20.6,15.6,27.3,24.2c6.7,8.7,9.4,14.2,9.2,23.6C482.7,219.7,478.4,247.6,478.4,247.6z",
    style: {
      fill: "rgb(30, 23, 33)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M468.1,224.1l-2.4,25.4c-0.1,0-0.2,0-0.4,0.1l2.4-25.5L468.1,224.1z",
    style: {
      fill: "rgb(247, 227, 210)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M474.7,221.1l-1.7,27.3c-0.1,0-0.2,0-0.4,0.1l1.7-27.4L474.7,221.1z",
    style: {
      fill: "rgb(247, 227, 210)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "513.9,228.3 511.1,233.2 507.2,234.5 507.2,230.4 509.5,224.5 \t\t\t\t\t\t",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M515.3,241.2c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.3-0.3,0.6-0.3,0.6l-10.5-4.8l2.7-6.8l0.2,0.2l3.6,2.4 c0,0,0.4,0.6,1,1.3c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.1,0.1,0.2c0.1,0.2,0.3,0.4,0.4,0.6l0,0 c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.2,0.3,0.3,0.4c0,0,0,0,0,0.1c1,1.4,2,2.8,2.1,3.3c0.1,0.3,0,0.8-0.1,1.2 C515.4,240.9,515.4,241.1,515.3,241.2z",
    style: {
      fill: "rgb(34, 29, 60)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M510.7,236.7c-1.1-0.8-2.1-1.6-2.6-3c-0.3-1-0.3-2.1-0.6-3.1l-0.2-0.2l-2.7,6.8L515,242 c0,0,0.1-0.2,0.3-0.6C514.7,239.5,512.1,237.8,510.7,236.7z",
    style: {
      fill: "rgb(20, 18, 40)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "539.4,218.2 537.6,223.6 534,225.5 533.3,221.5 534.4,215.2 \t\t\t\t\t\t",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M543.1,230.7c0,0.1,0,0.2,0,0.2c-0.1,0.4-0.1,0.6-0.1,0.6l-11.1-2.8l1.5-7.2l0.3,0.1l4,1.8 c0,0,0.5,0.5,1.3,1.1c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0.2,0.4,0.3,0.5,0.5l0,0 c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0,0,0.1,0.1c1.3,1.2,2.5,2.4,2.6,2.9c0.1,0.3,0.1,0.8,0.1,1.2 C543.2,230.3,543.2,230.5,543.1,230.7z",
    style: {
      fill: "rgb(34, 29, 60)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M537.7,227.1c-1.3-0.6-2.4-1.2-3.1-2.5c-0.5-0.9-0.6-2-1.2-3l-0.3-0.1l-1.5,7.2l11.1,2.8 c0,0,0.1-0.2,0.1-0.6C542.2,229.1,539.4,227.9,537.7,227.1z",
    style: {
      fill: "rgb(20, 18, 40)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M550.5,190.6c-3.2,9.3-11.6,29.2-11.6,29.2l-17.3-1.1c0,0,8.7-28.8,8.8-29c0-0.2-0.5-18.2-3.4-19.5 c-3-1.2-22.2-11.1-24.2-12.2c-2.1-1.1-16.4-10.2-13.1-14c3.3-3.9,6.9-8.5,6.9-8.5l5,1.2l6.5,1.5c0,0,0.2,4.3,1.2,6.1 c0.8,1.4,8,4.7,9.8,5.5c0,0,0,0,0,0c0.3,0.1,0.4,0.2,0.4,0.2s30.4,18.5,31.1,21C551.1,173.5,553.7,181.3,550.5,190.6z",
    style: {
      fill: "rgb(20, 18, 40)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M519,149.8c-2.8,2.1-6.3,4.6-7.1,4.7c-1.4,0.3-6.6,1.7-7.8-1.9c-1.2-3.7-6.4-10.4-5.7-11.7 c0.5-1,1.4-3.2,3.1-4.2l6.5,1.5c0,0,0.2,4.3,1.2,6.1C509.9,145.8,517.1,149,519,149.8z",
    style: {
      fill: "rgb(34, 29, 60)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M227.1,299.9l-9.6-25.6c-0.1-0.3,0-0.7,0.4-0.8l10.1-3.8l10.1,26.8l-10.1,3.8 C227.6,300.4,227.2,300.3,227.1,299.9z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M234.8,299.6l-11.3-30.1c-1.3-3.5,10-15.1,10-15.1l18.8,49.9C252.3,304.3,236.1,303.1,234.8,299.6z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M208.6,262.6c-1.3,0.5-2.7,0.5-3.9-0.1l-15.8-7.1c-1.5-0.7-1.3-2.9,0.2-3.3l0.3-0.1l66.9-19.1 c1.4-0.4,2.9-0.2,4.1,0.6l7.5,4.9L212.5,261L208.6,262.6z",
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M287.8,291.1l-2.4,8.7c-0.4,1.4-1.4,2.6-2.7,3.2l-63.1,30c-1.5,0.7-3-0.8-2.4-2.3l7.2-15.8 c0.6-1.2,1.6-2.2,2.9-2.6L287.8,291.1z",
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M231.8,276.2l-9.3-24.7l40.9-13.4c8.9-3.4,18.8,1.1,22.2,10l2.6,6.8L231.8,276.2z",
    style: {
      fill: "rgb(0, 176, 237)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M236.5,288.7l9.3,24.7l39.6-16.9c8.9-3.4,13.4-13.3,10-22.2l-2.6-6.8L236.5,288.7z",
    style: {
      fill: "rgb(0, 176, 237)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M578.5,153.5l-15,17.4c-4.7,4.4-9.7,8.4-14.9,12c-0.3,0.2-0.5,0.4-0.8,0.5c-1.2,0.8-2.4,1.6-3.7,2.3 c-1.2,0.7-2.9,1.7-4.9,2.8c-0.5,0.3-0.9,0.5-1.4,0.8c-0.2,0.1-0.4,0.2-0.6,0.3c-10.1,5.5-20.4,10.8-30.9,15.9 c-2.8,1.4-5.6,2.7-8.3,4c-0.2,0.1-0.4,0.2-0.6,0.3c-2.5,1.2-5.1,2.4-7.6,3.6c-13,6-26.1,11.7-39.3,17.2 c-0.2,0.1-0.4,0.2-0.6,0.2c-15.8,6.6-31.7,12.8-47.7,18.8c-0.2,0.1-0.4,0.2-0.6,0.2c-15.7,5.9-31.3,11.6-46.9,17.3 c-0.4,0.1-0.8,0.3-1.2,0.4c-0.2,0.1-0.4,0.1-0.6,0.2c-9.4,3.4-18.9,6.4-28.4,9.7c-9.7,3.2-19.5,6.3-29.3,9.3 c-2.6,0.8-5.3,1.6-7.9,2.4c-19.5,5.8-38.3,10.7-45.8,12.7l-14.7-38.9c34.7-17.1,69.9-34.1,105.6-49.5c0.2-0.1,0.4-0.2,0.6-0.2 c15.7-6.8,31.6-13.2,47.5-19.2c0.2-0.1,0.4-0.2,0.6-0.2c8-3,16.1-5.9,24.2-8.7c8.1-2.7,16.1-5.4,24.3-7.9 c0.2-0.1,0.4-0.1,0.6-0.2c13.6-4.3,27.3-8.3,41-12.3c0.1,0,0.1,0,0.2,0c2.7-0.8,5.4-1.5,8.2-2.2c0.2-0.1,0.4-0.1,0.6-0.2 c3-0.8,6-1.6,8.9-2.6c3.4-1.2,6.4-2.2,8.7-2.9c5.3-1.7,16.5-4,25-5.6c0.2,0,0.4-0.1,0.6-0.1c0.5-0.1,1.1-0.2,1.6-0.3 c2.2-0.4,4.1-0.8,5.6-1c1.7-0.3,3.5-0.6,5.3-0.8c6.3-0.8,12.7-1.1,19.1-0.9l22.7,3.2C578.8,151.3,579.3,152.7,578.5,153.5z",
    style: {
      fill: "rgb(68, 204, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M546.8,178.8c-0.9-3-2.2-6.1-4.7-8.1c-3.1-2.4-6.8-1.5-9.8,0.4c-1.9,1.2-3.5,2.7-5.2,4.1 c-2.1,1.8-4.4,3.3-6.9,4.5c-5,2.5-10.4,4.6-15.7,6.6c-5.7,2.2-11.5,3.7-17.5,5.1c-5.9,1.4-11.7,2.8-17.5,4.7 c-5.8,1.9-11.5,4-17.4,5.8c-5.2,1.6-10.5,2.3-15.1,5.3c-2.3,1.5-4.4,3.3-6.5,4.9c-2.1,1.6-4.3,3.1-6.4,4.7 c-4.2,3.1-8.4,6.2-13.2,8.1c-5,2-10.4,2.7-15.7,3.4c-10,1.5-20.3,2.8-29.1,8.2c-4.4,2.7-8,6.6-12.8,8.5 c-2.6,1-5.4,1.3-8.1,1.7c-2.5,0.3-4.9,0.6-7.4,0.8c-4.6,0.4-9.4,0.7-13.8,2.6c-4,1.7-7.6,5-10.1,8.5c-1.3,1.9-2.1,4-3.4,5.9 c-1.4,2.1-3.4,3.8-5.6,5c-2.5,1.4-5.3,2-8.1,1.9c-2.7-0.1-5.4-0.5-8.2-0.2c-1.7,0.2-3.4,0.7-5.1,1.3c-0.2-0.3-0.4-0.6-0.6-1 c-0.2-0.3-0.7,0.1-0.5,0.4c0.2,0.3,0.3,0.5,0.5,0.8c-0.3,0.1-0.6,0.2-0.9,0.4c-2.2,0.8-4.3,1.9-6.1,3.2 c-0.3,0.2,0.1,0.7,0.4,0.5c2-1.4,4.4-2.7,6.9-3.6c2.3,4.2,2.3,9.1,3.5,13.8c0.2,0.7,0.4,1.4,0.6,2.1c2.6-0.8,5.3-1.6,7.9-2.4 c9.8-3,19.6-6.1,29.3-9.3c9.5-3.3,19-6.4,28.4-9.7c0.2-0.1,0.4-0.1,0.6-0.2c0.4-0.1,0.8-0.3,1.2-0.4 c15.6-5.6,31.3-11.3,46.9-17.3c0.2-0.1,0.4-0.2,0.6-0.2c16-6,31.9-12.3,47.7-18.8c0.2-0.1,0.4-0.2,0.6-0.2 c13.2-5.5,26.3-11.2,39.3-17.2c2.5-1.2,5.1-2.4,7.6-3.6c0.2-0.1,0.4-0.2,0.6-0.3c2.8-1.3,5.6-2.7,8.3-4 c10.4-5.1,20.7-10.4,30.9-15.9c0.2-0.1,0.4-0.2,0.6-0.3c0.5-0.3,1-0.5,1.4-0.8c2-1.1,3.7-2.1,4.9-2.8c1.2-0.8,2.5-1.5,3.7-2.3 C547.5,181.8,547.2,180.3,546.8,178.8z",
    style: {
      fill: "rgb(68, 204, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M506.3,205.5c-2.8,1.4-5.6,2.7-8.3,4c-0.2,0.1-0.4,0.2-0.6,0.3c-2.5,1.2-5.1,2.4-7.6,3.6l-0.7-2 l-7.1-18.8l-10.6-28.1c2.7-0.8,5.4-1.5,8.2-2.2c0.2-0.1,0.4-0.1,0.6-0.2c3-0.8,6-1.6,8.9-2.6L506.3,205.5z",
    style: {
      fill: "rgb(118, 223, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M295.2,286.8c-1,0.3-2.1,0.6-3.2,0.9c-0.2,0.1-0.4,0.1-0.6,0.2c-18.5,5.5-37,10.4-46.6,13 c-0.2,0-0.4,0.1-0.6,0.2c-1,0.3-2,0.5-2.8,0.7l-4.2-11.1l-10.5-27.8c0.9-0.4,1.7-0.8,2.6-1.3c0.2-0.1,0.4-0.2,0.6-0.3 c14.5-7.1,28.9-14.4,43.6-21c0.2-0.1,0.4-0.2,0.6-0.3c1-0.4,2-0.9,3-1.3l12.2,32.5c0,0,0,0,0,0L295.2,286.8z",
    style: {
      fill: "rgb(118, 223, 255)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M292.1,287.8c-0.2,0.1-0.4,0.1-0.6,0.2l-17.9-47.5c0.2-0.1,0.4-0.2,0.6-0.3L292.1,287.8z",
    style: {
      fill: "rgb(68, 204, 255)"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M244.8,300.9c-0.2,0.1-0.4,0.1-0.6,0.2l-14.9-39.4c0.2-0.1,0.4-0.2,0.6-0.3L244.8,300.9z",
    style: {
      fill: "rgb(68, 204, 255)"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M578.5,153.5c0,0-2.7,4.6-7.3,10.1c-1.2,1.5-2.6,3-4.1,4.5c-7.1,7.1-13.2,11.2-18.5,14.8 c-1.5,1-3,2-4.5,2.9l-6.3-16.6l-7.3-19.4c1.7-0.3,3.5-0.6,5.3-0.8c6.3-0.8,13.1-1.6,23.1-1c2.3,0.1,4.6,0.4,6.8,0.8 c6.5,1,12,2.5,12,2.5c0.4,0,0.7,0.2,0.9,0.4C579,152.2,579,153,578.5,153.5z",
    style: {
      fill: "rgb(0, 176, 237)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M578.5,153.5c0,0-2.7,4.6-7.3,10.1c-1.2,1.5-2.6,3-4.1,4.5c-7.1,7.1-13.2,11.2-18.5,14.8 c-1.5,1-3,2-4.5,2.9l-6.3-16.6c6.3-2.3,16.7-6.2,24-9.2c7.3-3,13.4-6.3,16.8-8.2C579,152.2,579,153,578.5,153.5z",
    style: {
      fill: "rgb(0, 176, 237)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M286.3,263L286.3,263c0.7,1.8,0,3.8-1.6,4.4l-48.2,21.1l-4.5-11.8l50.1-16 C283.8,260.2,285.6,261.2,286.3,263z",
    style: {
      fill: "rgb(0, 176, 237)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M275,269.5l-73.6,27.7c-1.1,0.4-2.3-0.1-2.7-1.2c-0.4-1.1,0.1-2.3,1.2-2.7l73.6-27.7 c1.1-0.4,2.3,0.1,2.7,1.2c0.2,0.5,0.2,1.1-0.1,1.6C275.9,268.9,275.5,269.3,275,269.5z",
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M548.5,182.9c-1.5,1-3,2-4.5,2.9c-1.2,0.7-2.9,1.7-4.9,2.8l-6.6-17.5l-7.6-20.3c2.2-0.4,4.1-0.8,5.6-1 c1.7-0.3,3.5-0.6,5.3-0.8l6.9,18.3L548.5,182.9z",
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M450.5,230.6c-0.2,0.1-0.4,0.2-0.6,0.2l-20.3-53.7c0.2-0.1,0.4-0.1,0.6-0.2L450.5,230.6z",
    style: {
      fill: "rgb(245, 220, 201)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M537.2,189.7l-14.5-38.5c0.2,0,0.4-0.1,0.6-0.1l14.4,38.3C537.5,189.5,537.4,189.6,537.2,189.7z",
    style: {
      fill: "rgb(118, 223, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M402.2,249.7c-0.2,0.1-0.4,0.2-0.6,0.2L380.5,194c0.2-0.1,0.4-0.2,0.6-0.2L402.2,249.7z",
    style: {
      fill: "rgb(118, 223, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M353.6,267.6c-0.2,0.1-0.4,0.1-0.6,0.2l-20.5-54.4c0.2-0.1,0.4-0.2,0.6-0.2L353.6,267.6z",
    style: {
      fill: "rgb(118, 223, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M277.8,245.2c0.4-0.2,0.6-0.6,0.5-1.1c-0.2-0.4-0.6-0.6-1.1-0.5c-0.4,0.2-0.6,0.6-0.5,1.1 C276.9,245.2,277.4,245.4,277.8,245.2z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 288.8,
    transform: "matrix(0.9593 -0.2825 0.2825 0.9593 -70.8379 86.9718)",
    className: "st19",
    width: 48.4,
    height: 0.6,
    style: {
      fill: "rgb(68, 204, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 239.7,
    y: 282.6,
    transform: "matrix(0.9414 -0.3373 0.3373 0.9414 -79.9597 105.5603)",
    className: "st19",
    width: 48.2,
    height: 0.6,
    style: {
      fill: "rgb(68, 204, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 229.7,
    y: 256.4,
    transform: "matrix(0.9069 -0.4214 0.4214 0.9069 -84.5101 130.89)",
    className: "st19",
    width: 48.4,
    height: 0.6,
    style: {
      fill: "rgb(68, 204, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 232.2,
    y: 262.6,
    transform: "matrix(0.9297 -0.3684 0.3684 0.9297 -78.8271 112.8993)",
    className: "st19",
    width: 48.2,
    height: 0.6,
    style: {
      fill: "rgb(68, 204, 255)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M208.6,262.6c-1.3,0.5-2.7,0.5-3.9-0.1l-15.8-7.1c-1.5-0.7-1.3-2.9,0.2-3.3l0.3-0.1l23.1,9L208.6,262.6z ",
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M227.3,312.2c-1.3,0.4-2.3,1.4-2.9,2.6l-7.2,15.8c-0.7,1.5,0.9,3,2.4,2.3l0.3-0.1l11.4-22L227.3,312.2z",
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M220.5,290l-19.1,7.2c-1.1,0.4-2.3-0.1-2.7-1.2c-0.4-1.1,0.1-2.3,1.2-2.7l19.1-7.2L220.5,290z",
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M578.5,153.5c0,0-2.7,4.6-7.3,10.1l-2.5-6.7l-3-8.1c6.5,1,12,2.5,12,2.5c0.4,0,0.7,0.2,0.9,0.4 C579,152.2,579,153,578.5,153.5z",
    style: {
      fill: "rgb(0, 149, 214)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M199.8,252.3c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.2,0-0.3,0.2-0.4l57.5-16.9c0.2,0,0.3,0,0.4,0.2 c0.1,0.2,0,0.3-0.2,0.4L200,252.3C199.9,252.3,199.9,252.3,199.8,252.3z",
    style: {
      fill: "rgb(0, 149, 214)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M227.8,326.5c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.2,0-0.4,0.2-0.4l54.3-25.3c0.2-0.1,0.4,0,0.4,0.2 c0.1,0.2,0,0.4-0.2,0.4L228,326.4C227.9,326.5,227.9,326.5,227.8,326.5z",
    style: {
      fill: "rgb(0, 149, 214)"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M513.4,229.2l-15.6-3.6c0,0,4-10.2,6-14.8c2.4-5.5,4.5-11.6,6.2-17.2c0.3-0.9,0.5-1.7,0.7-2.6 c1.8-6.3,4.2-6.4-2.3-8.4c-1.9-0.6-3.4-1.2-4.9-1.9c-3.8-1.7-7.7-4.4-16.3-8.9c-10.6-5.4-17.3-6.5-21.3-14.5 c-1.7-3.4-3-7.6-2.7-11.9c0.3-5.2,1.2-9.4,1.2-9.4L504,138l0,0.1c-0.9,4.2-2.5,9.1,1,11.8c0.6,0.5,1.3,1,2.1,1.6 c9.8,7.9,29.3,17.7,30.4,26.7C538.8,188.8,513.4,229.2,513.4,229.2z",
    style: {
      fill: "rgb(34, 29, 60)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M464.3,136.1c0,0-0.8,4.2-1.2,9.4c1.7-0.9,4.1-0.7,5.9-0.4c1.6,0.2,3,0.3,4.4-0.6c1.2-0.8,2.1-1.4,3.6-1.6 c1.2-0.2,2.3-0.2,3.5-0.6c1-0.3,1.9-0.8,2.8-1c1.3-0.3,2.6,0,3.9,0.1c2.3,0.2,4.9-0.1,7.2-0.4c2.3-0.2,6.3-1.2,7.9-3.2 L464.3,136.1z",
    style: {
      fill: "rgb(20, 18, 40)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M542,119c0,0-0.3,0-0.8-0.1c-0.5-0.1-1.1-0.1-1.9-0.2c-6-0.7-20.4-2.5-26.2-3c-9.3-0.9-13.4,8.5-2.6,10.1 c4.6,0.7,32.1-2.3,32.1-2.3L542,119z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M563.6,47.9c0,0-0.3,0.3-0.8,0.7c-0.3,0.3-0.6,0.6-1.1,1c-5,4.7-19,17.6-22.4,19.4c-9.6,5.2-12-4.8-4-9.6 c5-3,17.5-10.3,22.7-13.3c0.3-0.1,0.5-0.3,0.7-0.4c0.4-0.2,0.7-0.4,1-0.6c0.1-0.1,0.2-0.1,0.3-0.2c0.3-0.2,0.4-0.2,0.4-0.2 L563.6,47.9z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M564.7,39.7c-0.5-0.5-1.4,0.5-1.7,0.8c-0.5,0.6-1.1,1.1-1.6,1.7c-0.7,0.9-1.2,2.7-1.2,2.7s1.5,2.2,2.2,2.7 c0.3,0.2,0.6,0.3,0.8,0.3c0,0,0.5-0.2,0.5-0.2s0.4-0.1,1-0.5c0.6-0.4,3.6-1.9,3.7-2.2c0.3-0.9-0.7-2.4-0.7-2.4l-0.7-1 c0,0,0.3-0.6,1.6-1.7c0.3-0.3,1.4-1.3,1.1-1.6c-0.3-0.4-2,0.8-2.3,1c-0.7,0.5-1.4,1-2.1,1.5c-0.4,0.3-0.7,0.5-1.1,0.8 c0,0-0.8,0.5-0.8,0.4c0-0.3,0.4-0.8,0.6-1.1c0.2-0.2,0.6-0.6,0.7-0.9C564.9,39.9,564.9,39.8,564.7,39.7z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M506,56.4c0-0.8,0.3-1.4,0-2.2c-0.2-0.7-0.5-1.2-1-1.7c-0.2-0.2-0.5-0.4-0.8-0.5 c-0.5-0.4-0.7-0.9-1.1-1.4c-0.3-0.4-0.5-0.6-0.9-0.7c-1-0.4-1.8-0.2-2.6,0.3c-0.7-0.3-1.5-0.6-2.4-0.5 c-1.3,0.2-1.9,1.3-3.2,1.7c-1,0.3-2.2,0.3-3,1.2c-0.2,0.2-0.4,0.4-0.5,0.7c-1,0.2-1.9,1-2.4,1.9c-0.4,0.7-0.5,1.6-0.3,2.4 c0.1,0.3,0.2,0.5,0.3,0.9c0.2,0.7,0.1,1.3,0.2,2c0.1,0.8,0.5,1.6,0.9,2.3c0.6,1,1.3,2,1.8,3.1c0.3,0.7,0.5,1.4,0.9,2 c0.2,0.3,0.4,0.5,0.6,0.7c0,0,0.1,0.1,0.1,0.1c0.4-0.8,1-2.1,1-2.9c-0.4-1-1-1.8-1-2.7c-0.1-1.1,1-2,1.8-1.4 c0.5-0.2,0.4-0.9,0.4-1.3c0-0.5-0.1-0.9-0.1-1.3c0.1-0.5,0.4-0.9,0.7-1.3c0.1,0.9-0.1,1.9-0.1,2.8c0,1.2,0.2,2.5,0.1,3.7 c-0.1,1.8-1.4,3.3-2.7,4.5c0.6,0.3,1.3,0.2,1.9,0c1.6-0.4,2.9-1.5,4.2-2.4c0,0,0,0,0.1,0c1.4-0.9,3.4-1.6,4.5-3 c0.2-0.3,0.3-0.6,0.4-0.9c0.3-0.5,0.6-0.8,1-1.3c0.1-0.1,0.1-0.2,0.2-0.3c0.1,0.1,0.3,0.2,0.4,0c0.3-0.5,0.7-1.1,0.8-1.8 C506.6,58,506,57.4,506,56.4z",
    style: {
      fill: "rgb(150, 73, 57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M499.4,53.3c-3.8,0.3-6.3,3-8.4,5.8c-0.1,0.1-0.1,0.2,0,0.3c0.3,2.4,0.6,4.9,1.1,7.3 c0.5,2.2,2.8,5.1,2.8,5.1c3.4,1,9.1,2.1,11.3-1.4c1.7-2.7,0.4-8.6-0.4-11.4C504.9,55.8,503.1,53,499.4,53.3z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M493.2,66c0,0-1.7,7.2-2.7,10c-0.4,1.1-0.8,2.1,0.2,3.1c1,1,2.9,1,4.2,1.1c1.6,0.1,3.2,0,4.7,0.2 c0.1,0,0.2,0,0.2,0c0,0,0.2,0,0.2,0l0.8-5l0.5-2.7l0.2-1.2L493.2,66z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M501.3,72.7l-0.5,2.7c-0.1,0-0.1,0-0.2-0.1c-0.5-0.1-0.2-0.4-0.9-1c-0.7-0.6-0.5-0.4-0.7-1 c-0.2-0.6-1.1-0.7-1.4-1.5c-0.3-0.7,0.3-0.7,0.4-0.7c0.1,0,0.6,0.5,1.4,0.9C500.2,72.5,501.3,72.7,501.3,72.7z",
    style: {
      fill: "rgb(242, 128, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M504.8,56.4c0,0-1.2-1.2-1.8-1.7c-0.6,0.5-1.6,0.7-2.2,0.8c-0.6,0.1-1.2,0-1.8,0.3 c-0.5,0.2-1,0.6-1.6,0.9c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0-0.4,0-0.6,0.1c0,0-0.1,0.1-0.1,0.1c-0.2,0.2-0.3,0.4-0.5,0.6 c-0.3,0.4-0.6,0.8-0.7,1.3c-0.1,0.5,0,0.9,0.1,1.3c0,0.5,0.1,1.1-0.4,1.3c-0.8-0.7-1.9,0.3-1.8,1.4c0.1,0.9,0.6,1.8,1,2.7 c0,0.8-0.6,2.1-1,2.9c-0.2,0.4-0.3,0.6-0.3,0.6s-0.2-0.6-0.4-1.4c-0.4-1.3-0.9-3.2-1.1-4c-0.3-1.4-0.6-2.8-0.4-4.3 c0.1-0.6,0.3-1.1,0.5-1.5c0.8-1.4,2.4-2.5,3.8-3.2c2.1-1.2,5.7-2.7,8.2-2.1C504.1,52.8,504.8,56.4,504.8,56.4z",
    style: {
      fill: "rgb(150, 73, 57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M493.4,56.2c-0.9,0.6-1.2,1.8-2.3,1.6c-0.2,0-0.4-0.1-0.6-0.2c-0.6-0.3-0.2-0.3-1-0.5 c-0.3,0-0.6-0.1-0.9-0.1c-0.2-0.5-0.3-1.1-0.3-1.6c0-0.1,0-0.2,0-0.3c-0.4,0.7-0.5,1.6-0.3,2.4c0.1,0.3,0.2,0.5,0.3,0.9 c0.2,0.7,0.1,1.3,0.2,2c0.1,0.8,0.5,1.6,0.9,2.3c0.6,1,1.3,2,1.8,3.1c0.3,0.7,0.5,1.4,0.9,2c0.2,0.8,0.4,1.4,0.4,1.4 s0.1-0.2,0.3-0.6c0.4-0.8,1-2.1,1-2.9c-0.4-1-1-1.8-1-2.7c-0.1-1.1,1-2,1.8-1.4c0.5-0.2,0.4-0.9,0.4-1.3c0-0.5-0.1-0.9-0.1-1.3 c0.1-0.5,0.4-0.9,0.7-1.3c0-0.1,0-0.3-0.1-0.4C495.3,55.9,494.4,55.5,493.4,56.2z",
    style: {
      fill: "rgb(150, 73, 57)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M513.6,108.8c-0.1,1-0.2,2.1-0.2,3.1c-0.8,8.6-1.8,16-2.1,17.8c-0.4,2.4-0.8,4.5-0.9,5.9 c0,0.2-0.1,0.4-0.1,0.6c-0.9,3.5-6.8,3.7-6.8,3.7l-39-3.4c0,0-2.6-0.9-2-5.2c0.6-4.3,7.2-30.1,8.4-35.3 c1.8-7.5,4.8-15.8,9.7-19.9c2.6-2.1,11.8-3,11.8-3l7.1,2.7c0,0,1.5-1.5,2.3-1.4c3,0.6,7.4,0.7,10,4.5 C514.6,83.3,514.5,96.8,513.6,108.8z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M511.2,129.7c-0.4,2.4-0.8,4.5-0.9,5.9c0,0.2-0.1,0.4-0.1,0.6c-2.8-0.5-6.6-1.5-10.4-2.9 c-7.1-2.7-7.3-0.9-11.5-3c-4.2-2.1-4.6-2.1-8.1-6.9c-3.1-4.2-7.2-21-6.3-20.7c0.8,0.4,6.8,10.7,7.8,12.6c1,1.9,10.4,6.1,12,6.5 c1.5,0.4,6.9,1.8,6.9,1.8l10.5,5.7C511,129.3,511.1,129.4,511.2,129.7z",
    style: {
      fill: "rgb(176, 238, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M558.3,52.6c-0.4-1.7-2.5-5.3-2.5-5.3l-1.9,1c0,0-7.2,2.3-9.4,3.6c-4.5,2.7-45.3,24-45.3,24 s4.3,3.3,4.4,6.5c0.1,3.1,1.4,6.5,2.7,9.3c0.8,1.6,1.8,3.1,2.6,4.7c0.4,0.8,0.8,1.9,1.5,2.5c1,0.7,2.3,0.3,3.4-0.3 c0.8-0.4,1.5-1,2-1.4c2.7-2,5.2-4.5,7.8-6.6c2.7-2.2,5.2-4.5,7.5-7.1c0.1-0.1,0.1-0.2,0.2-0.2c2.5-3,4.8-5.8,8.1-8.1 c2.5-1.8,5.3-3.2,7.2-5.7c0.9-1.3,1.6-2.7,2.4-4c0.9-1.6,2.3-1.5,3.7-2.4c2.2-1.3,3.1-3.2,3.6-5.4c0.8-0.5,2.4-1.9,2.5-2.6 C559.1,54.3,558.6,53.8,558.3,52.6z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M486.5,79c0,0,10.1,10.9,15,20.3c4.4,8.5,8,9.9,9.3,11.2c0.9,0.9,11.3,5,17.2,5.5c2.9,0.2,4.7,1.1,4.7,1.1 l2.6,0.2c0,0,0.8,8.2,0.3,8.6c-0.5,0.4-2.1,0.3-3.4,0.4c-1.3,0.1-2.8,2.6-8,2.4c-5.1-0.2-2.5-0.5-11.6,0.4 c-9.1,0.8-6.1,0-13.1-1.6c-7.1-1.6-15.1-2.4-17.3-7.3c-2.3-5-10.7-24.7-10.7-24.7L486.5,79z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M531.3,83.3c-2.3,2.6-4.8,4.9-7.5,7.1c-2.6,2.2-5.1,4.6-7.8,6.6c-0.5,0.4-1.9,1.3-1.9,1.3s-0.6-4-1.5-9.6 c-1-5.9-3.6-7.2-3.2-8.8c0.2-0.9,5.1,2.9,6.3,5.6c1.2,2.7,2.2,8.1,5.2,3.9c0.3-0.4,0.4-1.1,0.5-1.5c0.2-0.9,0.5-1.8,0.9-2.6 c0.4-0.8,0.8-1.7,1.6-2.2c1.1-0.9,2.4-0.5,3.6-0.2c0.7,0.1,1.4,0.2,2,0.2C529.7,83.3,531.2,83.5,531.3,83.3z",
    style: {
      fill: "rgb(176, 238, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M513.6,108.8c-0.1,1-0.2,2.1-0.2,3.1c-2.1-0.8-5.7-2.4-7.2-3.3c-2.1-1.4-2.5-1.8-3.3-4 c-0.8-2.2-1.4-1.7-2.7-4.7c-1.3-3-0.5-4.2-2.1-6.9c-1.6-2.6-3.1-4.9-3.3-5.6c-0.3-0.7,4.2,2.4,5.6,5.7c1.4,3.4,0.9,5.7,3.5,8.1 c2.6,2.3,1.3,3,4.3,4.9C509.5,106.9,511.6,107.9,513.6,108.8z",
    style: {
      fill: "rgb(176, 238, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M542,119c0,0,4.4,0.8,6.5,0.9c2.1,0.1,4.8-0.1,4.9,0.5c0.1,0.6-2.8,1.3-5.2,2c-2.3,0.7-5.6,1-5.6,1 l-1.8-2.6L542,119z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M555.6,83.6l-11.3,34l25.7,2.6l11.6-32c0.2-0.5-0.1-1-0.6-1.1L556.5,83C556.1,83,555.7,83.2,555.6,83.6z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M570,120.3l-0.3,1.3c-0.1,0.4-0.5,0.7-0.9,0.6l-44.4-4.9c-0.5,0-0.8-0.5-0.7-0.9l0-0.3 c0-0.5,0.5-0.8,0.9-0.7L570,120.3z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M570.1,96.1c-0.1,0.6-1.2,0.9-2.5,0.7c-1.3-0.2-2.3-0.8-2.2-1.4c0.1-0.6,1.2-0.9,2.5-0.7 C569.2,94.9,570.1,95.5,570.1,96.1z",
    style: {
      fill: "rgb(77, 69, 82)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M569.2,121C569.2,121,569.2,121,569.2,121l-24.3-3c-0.2,0-0.3-0.2-0.3-0.4c0-0.2,0.2-0.4,0.4-0.3l24.3,3 c0.2,0,0.3,0.2,0.3,0.4C569.6,120.9,569.4,121,569.2,121z",
    style: {
      fill: "rgb(77, 69, 82)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M490.5,73.7c0,0,1-2.9,1.4-2.9c0.4,0,7.7,4.9,7.7,5.1C499.5,76.1,490.5,73.7,490.5,73.7z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M499.1,75.9c0,0,2.3-2.4,2.3-2.3c0,0.1,0.8,1,0.8,1L499.1,75.9z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M519.1,181.2c-2.2-1-4.8,0.6-7.1,0c-1.3-0.3-2.6-0.8-3.9-0.8c-1.3,0-2.6,0.3-3.9,0.3c-0.2,0-0.4,0-0.7,0 c1.5,0.7,3.1,1.3,4.9,1.9c6.5,2,4,2.1,2.3,8.4c-0.2,0.8-0.5,1.7-0.7,2.6c1.9-0.5,4.2-2.3,5.3-3.5c0.9-0.9,1.4-1.9,2.3-2.7 c0.9-0.8,1.9-1.5,2.5-2.5C520.9,183.6,520.6,181.9,519.1,181.2z",
    style: {
      fill: "rgb(20, 18, 40)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M456,255.4l-2.8,0.4l-0.4,0.1l-5.4,0.8l-0.4,0.1l-5.4,0.8l-0.4,0.1l-4.1,0.6c0,0,0.8-6.1,1.5-8.2 c0.8-2.2-0.9-9.2,1.8-12.2c2.8-3-0.9-6.2,2.1-13.7c1.2-2.9,1.7-4.6,1.8-5.7l0,0c0.2-1.7-0.7-1.9-1.4-2.9c-1.1-1.6-1-4.4-3.5-7.3 c-0.4-0.5-1.6-1.3-3.3-2.3c-7.7-4.6-23.8-13.9-28.9-21c-3.5-4.9-5-11.7-3.9-18.4c0,0,0-0.1,0-0.1c0.5-2.8,2.7-8.5,4.4-12.7 c1.2-3,2.2-5.2,2.2-5.2l22.9,2.4c0,0,0.5,18.9,2.4,20c6.7,3.7,27.5,26.3,28.4,36.5C464.6,217.6,456,255.4,456,255.4z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M453.2,255.9l-0.4,0.1c2.1-11.5,7.7-43.2,6.6-49.2c-1.3-7.4-11.3-16.4-22.9-26.7l-0.1-0.1 c-11.8-10.5-10-25.3-10-25.5l0.4,0c0,0.1-1.8,14.8,9.8,25.2l0.1,0.1c11.7,10.4,21.8,19.4,23,26.9 C460.9,212.8,455.4,244.2,453.2,255.9z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.4,256.8l-0.4,0.1c2.2-13.9,7.2-46.4,5.5-51.3c-1.1-3.3-7.4-8.5-14-14.1c-5.8-4.8-11.7-9.8-15.1-14.1 c-7.1-9.3-7.2-24.4-7.2-24.5l0.4,0c0,0.2,0,15.1,7.1,24.3c3.3,4.3,9.3,9.2,15,14c6.7,5.6,13,10.8,14.1,14.2 C454.6,210.4,449.7,242.7,447.4,256.8z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M445.6,226.3c-0.7,3.2-1.3,5.9-1.3,7.6c0.1,3.9-1.8,18-2.7,23.7l-0.4,0.1c0.8-5.7,2.8-19.9,2.7-23.8 c-0.1-1.8,0.6-4.5,1.3-7.7c1.3-5.7,2.9-12.8,1.2-17.4c-1.4-4-10-10-18.2-15.7c-6.7-4.7-13-9.1-15.5-12.4 c-5.7-7.4-3.1-25.2-2.9-26l0.4,0.1c0,0.2-2.7,18.4,2.9,25.7c2.5,3.3,8.8,7.6,15.5,12.3c8.3,5.8,16.9,11.8,18.4,15.9 C448.5,213.4,446.9,220.5,445.6,226.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M431.5,152.9c-0.1,1-0.4,1.8-0.9,2.6c-1.9-2-4-3.7-6.9-3.6c-1.7,0.1-3.3,0.6-5,0.8c-0.7,0.1-1.3,0.1-2,0.1 c-0.1,0-0.2,0-0.4,0c-0.9,0-1.9,0-2.8,0.1c-1.7,0.1-3.7,0.3-5.6,0.8c-1.7,4.2-3.9,9.9-4.4,12.7c0.1,0,0.2,0,0.3,0 c1.8-0.2,3.6-0.6,5.3-1.2c0.1,0,0.3-0.1,0.4-0.1c1.2-0.4,2.3-0.9,3.5-1.4c1.5-0.6,2.9-1.2,4.4-1.5c0.1,0,0.2,0,0.4-0.1 c0.1,0,0.3,0,0.5-0.1c1-0.1,2.1-0.2,3.1-0.5c1.7-0.4,3.6-1,5.4-1.9c0.1-0.1,0.2-0.1,0.4-0.2c2.7-1.4,5-3.6,5.3-6.7 C432.2,152.5,431.5,152.5,431.5,152.9z",
    style: {
      fill: "rgb(30, 23, 33)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M426.9,159.6c-0.1,0.1-0.2,0.1-0.4,0.2c-0.3-3.2-0.1-5.3,0-5.4l0.4,0 C426.9,154.5,426.6,156.6,426.9,159.6z",
    style: {
      fill: "rgb(247, 227, 210)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M417.7,162.2c-0.1,0-0.2,0-0.4,0.1c-1-5-1-8.9-1-9.4l0,0l0.4,0l0,0C416.7,153.3,416.7,157.3,417.7,162.2 z",
    style: {
      fill: "rgb(247, 227, 210)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M410.1,154.8c0,0.1-0.7,4.8-0.7,10.3c-0.1,0-0.3,0.1-0.4,0.1c-0.1-5.5,0.6-10.1,0.7-10.5L410.1,154.8z",
    style: {
      fill: "rgb(247, 227, 210)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M432.5,79.1c-0.1-1.6-0.5-3.4-1.8-4.5c-0.9-0.8-2.1-1.2-3.3-1.3c-0.7-0.1-1.5-0.1-2.1,0 c-2.4,0.2-5.2,1.6-7.2,3c-1.5,1-2.8,2.5-2.7,4.4c0.1,1.8,0.8,3.9,1.8,5.6c0,0,0,0,0,0c0.3,0.4,0.5,0.8,0.8,1.2 c0.4,0.6,1,1.2,1.6,1.8c0.1,0.1,0.1,0.1,0.2,0.2c0.2,0.2,0.5,0.4,0.7,0.5c0.2,0.1,0.4,0.2,0.7,0.3c0.5,0.1,1,0.2,1.5,0 c0.3-0.1,0.6-0.2,0.9-0.4c0.7-0.4,1.3-0.9,1.9-1.4c0.8-0.8,1.5-1.6,2.1-2.3c1.3-1.5,2.4-3.1,3.5-4.7c0.4-0.5,0.7-1,1.1-1.5 c0,0,0-0.1,0-0.1c0.2,0,0.3-0.1,0.3-0.3C432.5,79.3,432.5,79.2,432.5,79.1z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M431.3,80.1c-0.1,0.4-0.2,0.8-0.3,1.3c-0.3,1-0.6,2.1-1,2.9c-0.9,1.9-1.2,5.3-2.2,7.6 c-0.2,0.6-0.5,1.1-0.8,1.4c-0.2,0.3-0.5,0.5-0.7,0.7c0,0,0,0-0.1,0c-0.1,0.1-0.3,0.2-0.5,0.3c-1.4,0.7-2.8,1.2-4,2.2 c-0.3,0.2-0.5,0.5-0.8,0.7l-0.1,0c-0.5,0-0.9,0-1.4,0c-0.5,0-1,0-1.5-0.1c-1.6-0.2-2.5-0.9-4-1.5c-1.7-0.7-2.9-0.5-4.1-2.3 c-0.1-0.2-0.2-0.4-0.4-0.7c-0.2-0.4-0.4-0.9-0.6-1.3c-0.8-1-2.1-1.5-2.8-2.4c-0.2-0.3-0.4-0.6-0.7-0.9 c-0.2-0.2-0.5-0.3-0.6-0.6c-0.2-0.5-0.1-0.8,0.2-1.2c0.7-1,2-1.2,2.8-2c1-0.9,1.3-2.3,2.3-3.2c0.8-0.8,1.8-1.2,2.9-1.7 c1-0.5,1.7-1.1,2.4-1.8c0.3-0.3,0.6-0.7,1-1.1c0.2-0.3,0.5-0.5,0.7-0.7c2.7-2.4,6.9-3.4,10.4-2.4c0.8,0.2,1.7,0.6,2.4,1.1 c0.2,0.1,0.2,0.3,0.1,0.5c-0.1,0.1-0.2,0.2-0.3,0.2c0.3,0.3,0.6,0.6,0.9,0.9c0.2,0.2,0.3,0.5,0.5,0.7c0.1,0.1,0.2,0.3,0.2,0.5 c0.1,0.2,0,0.4-0.1,0.5C431.4,78.4,431.5,79.2,431.3,80.1z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M423.8,80.5C423.8,80.5,423.8,80.5,423.8,80.5c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.2,0-0.4,0-0.6,0 c-1.9,0.1-3.2,1.4-4.1,3c-0.1,0.1-0.1,0.2-0.2,0.4c-0.2,0.3-0.3,0.6-0.4,0.9c-0.3,0.6-0.6,1.2-1,1.7c0,0,0,0,0,0 c-0.2,0.2-0.4,0.3-0.6,0.5c-0.8,0.4-1.7,0.4-2.5,0.8c-0.6,0.4-1,0.9-1.1,1.6c-0.2,0.8-0.2,1.8-0.9,2.4 c-0.3,0.3-1.1,0.4-1.6,0.6c-0.3,0.1-0.6,0.3-0.8,0.4c0.1,0.2,0.2,0.5,0.4,0.7c1.2,1.8,2.4,1.6,4.1,2.3c1.4,0.6,2.3,1.3,4,1.5 c0.5,0.1,1,0.1,1.5,0.1c-0.1,0.5-0.2,1-0.3,1.4c0.9-0.3,1.4-0.8,1.7-1.4c0.3-0.6,0.5-1.2,0.7-2c0.1-0.4,0.2-0.8,0.4-1.1 c0.6-1.4,1.5-2.6,2.3-3.9c0.4-0.6,0.7-1.2,1-1.8c0-0.1,0.1-0.1,0.1-0.2C426.5,86.1,426.6,81.1,423.8,80.5z",
    style: {
      fill: "rgb(30, 23, 33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M417,75.7c-0.1-0.4-0.3-0.9-0.7-1.2c-0.7-0.8-1.9-1.3-2.6-1c-1,0.4-2.2,2-1.6,3c0.5,0.9,2.2,1.2,3.1,1 c0.1,0,0.1,0,0.2,0c0.6-0.1,1.3-0.5,1.5-1.2C417,76.1,417.1,75.9,417,75.7z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M433,80.6c-0.1-0.5-0.3-1-0.5-1.5c-0.4-0.9-0.9-1.8-1.5-2.5c-0.2-0.2-0.4-0.4-0.6-0.6 c-1-0.8-2.2-1.2-3.8-1.1c-3.7,0.3-6.2,3-8.3,5.9c-0.1,0.1-0.1,0.2,0,0.3c0.1,0.9,0.2,1.7,0.3,2.6l0,0 c0.2,1.6,0.5,3.1,0.8,4.7c0.1,0.3,0.2,0.7,0.3,1.1c0.2,0.6,0.4,1.2,0.6,1.8c0,0.1,0.1,0.2,0.1,0.3c0.5,1.4,1,2.6,1,2.6 s0.3,0,0.7,0.1c0.8,0.1,2.2,0.2,3.7,0.2c0.3,0,0.6,0,0.8,0c1,0,2-0.1,2.9-0.3c1.8-0.3,3.3-0.9,4-2.1 C435.2,89.2,433.9,83.4,433,80.6z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M429.4,96.8l0.1-2.7l0,0l0-1.2l-1.7-0.8l-3.5-1.7l-0.8-0.4l-1.7-0.8l-1.2-0.6c0,0-0.1,0.6-0.2,1.5 c0,0.4-0.1,0.8-0.1,1.3c0,0.2,0,0.3-0.1,0.5c-0.2,1.7-0.5,3.8-0.7,5.5c-0.1,0.5-0.2,1-0.3,1.4l0,0c-0.2,1.1-0.6,2.2,0.5,3 c1.1,0.8,3,0.7,4.3,0.6c1.6-0.1,3.1-0.4,4.7-0.4c0.1,0,0.2,0,0.2,0c0,0,0.2-0.1,0.2-0.1L429.4,96.8z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M429.5,94l-0.1,2.7c-0.1,0-0.1,0-0.2,0c-0.5-0.1-0.3-0.4-1-0.9c-0.7-0.5-0.5-0.3-0.8-0.9 c-0.3-0.6-1.2-0.6-1.5-1.3c-0.4-0.7,0.2-0.7,0.3-0.7c0.1,0,0.6,0.4,1.5,0.7C428.3,93.9,429.5,94,429.5,94z",
    style: {
      fill: "rgb(242, 128, 87)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M430.8,75.6c-1.2,1.3-2.7,1.4-4.3,1.8c-1.6,0.4-2.3,1.6-2.6,3c-0.2,0.9-0.3,2-0.4,2.9c-1,0.1-1.6,1-1.8,2 c-0.1,0.9,0.3,1.6,0.8,2.3c-0.4,1.1-2.2,4.1-2.2,4.1s-0.5-0.8-0.5-1.1c-0.2-2-1-4-1.5-6c-0.3-0.9-0.5-1.7-0.6-2.6 c-0.2-1.9,1-3.4,2.4-4.6c1.8-1.5,4-2.7,6.4-3.3c1.6-0.4,2.9-0.3,3.9,1c0,0,0.1-0.1,0.1-0.1C430.6,74.8,431.1,75.3,430.8,75.6z ",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M423.4,83.4c0.1-0.9,0.2-2,0.4-2.9c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.2,0-0.4,0-0.6,0 c-1.9,0.1-3.2,1.4-4.1,3c-0.1,0.1-0.1,0.2-0.2,0.3l0,0c-0.2,0.3-0.3,0.6-0.4,0.9c0.4,1.5,1,3.1,1.3,4.6 c0.1,0.4,0.2,0.9,0.2,1.3c0,0.4,0.5,1.1,0.5,1.1s0.1-0.1,0.2-0.3c0.2-0.3,0.4-0.7,0.7-1.2c0.2-0.4,0.5-0.8,0.7-1.3 c0.3-0.5,0.5-1,0.6-1.3c-0.5-0.7-0.9-1.4-0.8-2.3C421.8,84.3,422.5,83.5,423.4,83.4z",
    style: {
      fill: "rgb(30, 23, 33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423.5,87.3c0-0.4-0.4-0.9-0.8-0.6c-0.6,0.4,0,1.1,0.6,1C423.5,87.6,423.6,87.4,423.5,87.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M448,153.8c-3,1.4-6.1,1.9-9.2,2.1c-2.3,0.2-4.4,0.5-6.5,0.8c-2,0.3-4.1,0.7-6.4,1.1 c-2,0.4-4.3,0.7-6.8,1.1c-7.2,1-13.9,1.2-21.2,0.8c-0.3,0-0.6,0-0.9-0.1c1.1-13.3,2.5-31.4,2.9-35c0.9-8.1,2.3-19.2,9.8-24 c5.9-3.8,13.7-3.9,20.4-3.4c3.3,0.2,10.2,3.2,12.2,7.8c3.8,8.4,3.1,20,3.6,29.1C446.5,141.7,447.5,147.5,448,153.8z",
    style: {
      fill: "rgb(39, 217, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M419.7,124.3c0,0-5.3-11.9-5.4-12.4c-0.1-0.5,1.9-0.8,3.1,0.9c1.2,1.7,1,4,2.8,5.1 c1.8,1.1,6.5,6.8,6.5,6.8s-0.2,14.2-0.4,14.3C426.1,139,419.7,124.3,419.7,124.3z",
    style: {
      fill: "rgb(26, 196, 111)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M432.2,156.7c-2,0.3-4.1,0.7-6.4,1.1c-1.9-2.3-5.8-6.9-7.8-8.4c-2.8-2.1-4.9-8.3-6.5-10 c-1.7-1.7-2.3-2.2-3.3-4c-0.9-1.8-4.1-1.9-5.7-4.4c-1.1-1.7-1.9-8.3-1-8c0.9,0.3,3.7,7.9,4.1,7.9c0.4,0,2.8-1.2,2.8-1.2 l12.8,10.9L432.2,156.7z",
    style: {
      fill: "rgb(26, 196, 111)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M424.5,132.6c-0.5-3.6-0.6-7.3-0.3-10.9c0.4-4.3,2.2-7.2,2.5-7.4c0.4-0.2,19.7-3.1,19.7-3.1 c-1.7,5.6-2,11.5-1.5,17.3c0.1,1.1,2.2,14.5,3.1,14.3l-19.8,5c-0.6,0.1-3.4-12.3-3.6-13.5C424.7,133.7,424.6,133.2,424.5,132.6 z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M427.3,135.4c-0.1-0.2-0.1-0.4-0.1-0.5c-1-3.7-1.3-7.5-1.6-11.3c-0.3-4.3,1-7.4,1.3-7.7 c0.3-0.3,18.5-5.6,18.7-5.1c0.4,0.9,0,10.2,1.4,15.9c0.3,1.1,4.5,14,5.4,13.6c0,0-19.4,8.3-20.4,8.8 C431.6,149.2,428.1,138,427.3,135.4z",
    style: {
      fill: "rgb(176, 238, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M428.5,133.5c-0.5-3.6-0.6-7.3-0.3-10.9c0.4-4.3,2.2-7.2,2.5-7.4c0.4-0.2,19.7-3.1,19.7-3.1 c-1.7,5.6-2,11.5-1.5,17.3c0.1,1.1,2.2,14.5,3.1,14.3l-19.8,5c-0.6,0.1-3.4-12.3-3.6-13.5C428.6,134.5,428.5,134,428.5,133.5z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M432,134.6c-0.5-3.6-0.6-7.3-0.3-10.9c0.4-4.3,2.2-7.2,2.5-7.4c0.4-0.2,19.7-3.1,19.7-3.1 c-1.7,5.6-1.4,11-1.2,16.8c0.3,10.2,2.9,14.8,2.9,14.8l-19.8,5c-0.6,0.1-3.4-12.3-3.6-13.5C432.1,135.7,432.1,135.2,432,134.6z ",
    style: {
      fill: "rgb(176, 238, 255)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M445.6,166.2l-2.6,3.7c0,0-0.5-0.4-1.3-1.2c-0.3-0.3-0.7-0.6-1.1-1c-5.8-5.1-20.1-17.8-22.3-20.9 c-6.6-9.3,3.4-12.9,9.5-5.3c3,3.8,12.7,17.4,16.5,22.6c0.3,0.5,0.6,0.9,0.8,1.2C445.4,165.8,445.6,166.2,445.6,166.2z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M451.4,177.3c0.1-0.7-0.5-1.8-0.5-1.8s0.6,0.7,0.9,1.1c0.2,0.2,0.8,1,1,0.5c0.1-0.3-0.7-2.1-1-2.7 c-0.3-0.6-1-1.9-1-1.9s1.9,2.9,2.5,3.3c0.2,0.1,0.5,0,0.4-0.2c0-0.5-0.5-1.4-1-2.1c-0.7-1.1-1.4-2.1-2.3-3.1 c-0.7-0.8-4.9-4.1-4.9-4.1s-1.8,2.5-2.7,3.7c-0.1,0.1,2.4,2.9,3.7,4.2c0.8,0.8,2.4,2.6,2.7,2.8c0.1,0.1,0.3,0,0.4-0.1 c0.1-0.2,0-0.4,0-0.6c0,0,0.8,1.2,1.3,1.4C451.1,177.5,451.3,177.5,451.4,177.3z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M427.6,141.5c0,0-5.4,2-5.9,2.2c-0.5,0.1-5,0.6-5,0.6l-6.6-11.5l-1.6-2.8l11.2-5.5L427.6,141.5z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M419.5,97.3c0,0,4.1,2.1,5.2,2.5c1.2,0.4,3.1,2.2,4,2.7c0.9,0.5,1.2-1.2,1-2.7c-0.2-1.5-0.4-2.7-0.4-2.7 s-2.9-0.7-3.1-0.7c-0.2,0-3.8-0.5-4.3-0.2C421.6,96.4,419.5,97.3,419.5,97.3z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M430.9,130.2c0,0,14.7-6.1,20.4-8.2c7.9-3,11.5,6.5,0.3,9.2c-6.4,1.5-18.4,3.7-18.4,3.7L430.9,130.2z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M432.7,130.3c0,0-2.2-0.1-3.5,0.2c-1.3,0.3-1.9,0.3-2.3,0.6c-0.4,0.3-0.9,0.7-0.8,1.2 c0.1,0.5,0.5,1.3,0.9,1.8c0.4,0.5,0.5,1.4,1,1.8c0.7,0.6,0.9,0.6,1.8,0.6c1.6-0.1,3.6-1.6,3.6-1.6l0.4-1.9L432.7,130.3z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M432.9,130.2c0,0-1.4-0.8-2.4-0.9s-2.6,0.4-3.7,0.9c-1.1,0.6-1.3,0.6-1.4,1c-0.1,0.4,1,0.6,1.7,0.4 c0.7-0.1,2.5-0.6,2.5-0.6L432.9,130.2z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M386.2,242.4c-0.9,4.8-2,9.5-3.1,14.3c-0.1,0.4-0.2,0.8-0.3,1.2c-0.1,0.5-0.2,0.9-0.3,1.4 c-2.4,10.1-4.9,20.1-7.5,30.1c-0.5,1.9-1,3.8-1.5,5.7l-17-0.8c0,0,1.8-4.7,1.4-9.8c-0.4-5.1,2.3-7.7,1.7-12.3 c-0.6-4.6-0.8-12.6,0.8-17.6c0.4-1.1,0.7-2.4,0.9-3.7c0.2-1.2,0.4-2.5,0.5-3.7c0-0.1,0-0.1,0-0.2c0.4-3.2,0.4-5.8,0.4-5.8 s-1.3-1-2.9-2.3c0,0-0.1-0.1-0.1-0.1c-2-1.6-4.6-3.6-5.9-4.7c-1.2-1-19-18.8-21.5-21.6c-5.3-5.9-8.5-16.3-8.5-16.3l4.5-10.3 l0.5-1.5l0.7-2l8.5-0.4c0,0,0.5,0,0.5,0l16.5-0.7l0.5,6.8c0,0,7.6,11.1,15.2,19.5c3.9,4.3,9.6,12.1,12.6,17.1 c1.9,3.2,4.4,6.5,4.7,10.3C387.5,237.4,386.7,240.1,386.2,242.4z",
    style: {
      fill: "rgb(34, 29, 60)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.5,184.3c-0.3,0.2-10.1,9.3-11.5,14.2c-1.3,4.9-3.5,8.3-4.5,8.4c-1.1,0.1-1.2-1.9-6.7-2.9 c-5.5-1-13.6-1.6-13.6-1.6s4.9-6.3,7.9-7.7c3.1-1.4,10.3-4.6,13.8-6C350.5,187.3,361.5,184.3,361.5,184.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M316.6,68.7c0,0-0.6,15.9-1,21.9c-0.5,8.4-10.7,7.7-8.5-3.5c1.3-6.5,4.3-18.2,4.3-18.2L316.6,68.7z",
    style: {
      fill: "rgb(150, 73, 57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M315.8,70.2c0,0,1-2,1.3-3.3c0.3-1.3,0.5-1.8,0.4-2.4c-0.1-0.4-0.2-1.1-0.7-1.2c-0.5-0.1-1.4-0.1-2,0.1 c-0.6,0.2-1.5-0.1-2.1,0.1c-0.8,0.4-0.9,0.6-1.2,1.4c-0.6,1.4-0.1,3.9-0.1,3.9L313,70L315.8,70.2z",
    style: {
      fill: "rgb(150, 73, 57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M315.8,70.5c0,0,1.3-1,1.8-1.8c0.5-0.8,0.8-2.5,0.7-3.8c0-1.2,0-1.5-0.3-1.7c-0.4-0.3-0.9,0.7-1.1,1.3 c-0.2,0.7-0.5,2.5-0.5,2.5L315.8,70.5z",
    style: {
      fill: "rgb(150, 73, 57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M367.4,181.9c0,0-13.7,11.4-23.3,15.6c-9.6,4.2-18.8,4.9-18.8,4.9s-3.4-0.8-4.7-5.1 c-0.3-0.9-0.5-1.9-0.5-3.1c0-0.7-0.1-2-0.1-3.8c-0.1-6.8-0.3-20.1-0.3-28.9c0-3.7,0.1-6.5,0.2-7.9c0.2-3.1,0.5-6.2,0.8-9.2 c0.2-2,0.5-4,0.7-6c0.9-6.2,2.3-11.6,4.3-14.5c1.7-2.4,6-3.1,10.5-3.1c3.7,0,7.5,0.6,10,1.1c5.8,1.2,12.3,3.6,15.6,8.8 c4,6.3,3.2,14.1,4.5,21.2c0.2,1,0.4,2,0.6,3c1.4,8.5,2.2,15.8,2.4,17.6C370.2,180.1,367.4,181.9,367.4,181.9z",
    style: {
      fill: "rgb(109, 156, 250)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M340.8,139.4c-0.3,3.1-10.8,11.4-12.2,11.2c-1.4-0.2-2.9-1.3-4.3-2.6c-1.2-1.1-2.3-2.3-3.1-3.1 c-0.2-0.2-0.3-0.3-0.5-0.5c-1.5-1.5-2.9-3.1-4.3-4.7c-0.6-0.7-1.1-1.4-1.6-2.1c-5.6-7.5-9.9-17.3-12.1-26.3 c-0.3-1.3-0.6-2.6-0.8-3.9c0-0.6,0-1.3,0-1.9c-0.1-3.4-0.2-6.7,0.5-10c0.6-2.9,0.8-5,0.5-7.9c-0.3-3.1,1.4-4.9,1.9-7.7 c0.2-1.1-0.2-2-0.2-3.1c0-3.2,7.7-1.8,9.7-1.7c0.7,0.1,1.4,0,2.2,0.1c-0.1,6.2-0.3,16.1,0,18.6c0.4,3.7,3.3,9.7,8.5,16.9 c4.9,6.7,10.6,10,11.3,10.4c0.1,0,0.1,0,0.1,0S341.1,136.3,340.8,139.4z",
    style: {
      fill: "rgb(109, 156, 250)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M324.2,148c-0.1,0.7-0.1,1.5-0.1,2.4c0,5.6-2.4,9.1-4.5,11.1c0-3.7,0.1-6.5,0.2-7.9 c0.2-3.1,0.5-6.2,0.8-9.2c-1.5-1.5-2.9-3.1-4.3-4.7c1.5-0.2,3.4-0.6,5-1.2c1.1-0.4,2.1-1,2.7-1.7c2.3-2.9,3.9-8.4,5.9-8.8 c1.9-0.4-2.2,6.2-1.6,10.3C328.8,142,325,141.3,324.2,148z",
    style: {
      fill: "rgb(85, 150, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M349,183.6c-1.5-1.3-4.1,0.2-5.4,1c-1.4,0.8-2.8,1.8-4.2,2.6c-1.8,1-3.7,1-5.6,1.7 c-1.5,0.5-2.3,1.7-3.6,2.4c-2.1,1.1-4.6-0.1-6.7-0.6c-1.2-0.3-2.4-0.4-3.6-0.2c0,1.8,0.1,3.1,0.1,3.8c0.1,1.2,0.2,2.3,0.5,3.1 c0.4,0,0.8,0,1.2,0c3.1,0,5.9-0.4,8.8-1.5c3.3-1.3,6.7-2.7,9.8-4.3c1.9-1,3.5-1.8,5.5-2.4c1.1-0.4,2.2-0.9,2.9-1.9 C349.6,186.2,350.1,184.5,349,183.6z",
    style: {
      fill: "rgb(85, 150, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M293.2,200.4c0,0-2.9,6.6-1.1,11.8c0.1,0.3,0.2,0.6,0.3,0.9c-0.9,0.7-1.9,1.5-2.8,2.2 c-1.6,1.3-3.2,2.7-4.9,4.2c-0.4,0.3-0.8,0.7-1.2,1c-6-0.2-16.2-4-21.8-4.9c-7,3.1-9.8-8.2-16.6-16.5c-1.1-1.3-2.2-2.8-3.3-4.3 l0,0c-1.2-1.6-2.3-3.4-3.3-5.2c-0.4-0.7-0.7-1.3-1.1-2l0,0c-0.1-0.2-0.2-0.3-0.3-0.5l0,0c-0.3-0.6-0.6-1.1-0.8-1.7l0,0 c-1.1-2.3-1.9-4.6-2.4-6.9c-1-4.8,5.9-9.8,5.9-9.8s0,0,0,0c0,0,0,0,0,0c0.2-0.1,0.9-0.4,2-0.8c0.7-0.3,1.6-0.7,2.6-1.1 c1.1-0.5,2.3-1,3.5-1.5c0.5-0.2,1-0.5,1.6-0.7c3.1-1.4,6.3-2.8,8.6-4c0,0,0,0,0,0c0.7-0.3,1.8-0.9,3.3-1.6 c0.8-0.4,1.7-0.8,2.6-1.2c0.4-0.2,0.9-0.4,1.3-0.5c4.7-1.9,10.3-3.6,12.8-1.9c4.3,3,5.9,11.7,7.7,16.6 c1.7,4.7,3.5,10.8,4.8,14.9c0.3,1,0.6,1.9,0.8,2.6c0,0.1,0.1,0.3,0.1,0.4c1,2.8,1.6,5.3,1.8,7.2c0,0.5,0.1,0.9,0,1.3 C293.6,199.3,293.5,200,293.2,200.4z",
    style: {
      fill: "rgb(255, 213, 67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M270.6,188c-0.9,1.1-2.7,1.8-4.5,2.3c-1.6,0.4-3.2,0.7-4.3,1c-0.2,0.1-0.5,0.1-0.7,0.2 c-2.1,0.5-4.2,0.8-6.3,1.1c-0.9,0.1,0.9,3.3,0,3.4c-4.1,0.3-8.6-0.1-12.9-1c-3-0.7-6-1.6-8.8-2.8c-0.1,0-0.2-0.1-0.3-0.1 c-1.4-0.6-3-1.1-4.6-1.7c-3.2-1-6.4-2.1-8.5-4.4c-0.5-0.8-1-1.5-1.3-2.3c-0.5-1.3,0.1-4.3,0-5.7c-0.1-2-0.6-3-1.5-4.8 c-0.8-1.8-0.9-3.6-1.4-5.5c2.8,0.7,11.5,2.5,18.9,2c2-0.1,3.8-0.4,5.5-0.8c0,0,0,0,0,0c0.8-0.2,1.5-0.3,2.2-0.5 c0.9-0.2,1.7-0.5,2.4-0.7c1.8-0.6,3.1-1.2,3.9-1.6c0.4-0.2,0.7-0.4,0.9-0.4c0.1,0,0.1-0.1,0.1-0.1s0.4,0.1,1,0.3 c3.5,1,15,4.2,17.1,5.8C270.1,173.5,271.6,186.9,270.6,188z",
    style: {
      fill: "rgb(255, 213, 67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.4,167.1c-0.1-0.5-0.5-0.9-0.8-1.3c-0.1-0.2-0.3-0.3-0.4-0.5c-0.2-0.2-0.3-0.4-0.4-0.6 c-0.5,0.2-1,0.5-1.6,0.7c0.1,0.2,0.2,0.4,0.4,0.6c0.4,0.4,0.8,0.7,1,1.2c0.4,2-2.9,1.8-4,1.2c-0.4-0.2-0.7-0.5-0.9-0.9 c-0.1-0.2-0.1-0.4-0.1-0.6c0,0,0-0.1,0-0.1c-1,0.4-1.9,0.8-2.6,1.1c0,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.1,0.1,0.2 c0.5,0.5,1.1,0.5,1.7,0.6c0.9,0.1,1.5,0.4,2.2,0.8c0.2,0.1,0.4,0.3,0.6,0.4c1.3,0.5,2.3-0.5,3.4-1.1 C251.1,168.6,251.6,168.2,251.4,167.1z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M283.7,172.1c-0.4,2.1-0.7,0.5-1.3,2.5c-0.1,0.2-0.1,0.5-0.2,0.7c-0.3,1.1-0.7,2.7-1.2,4.2 c-0.6,1.8-1.4,3.5-2.5,4.4c-0.6,0.4-4.1,0.2-7.7-0.6c-3.8-0.7-7.6-1.9-8.5-3.2c-1-1.5-2.6-7.3-3.7-12c-0.8-3.5-1.5-6.4-1.5-6.4 s0,0,0.1-0.1c0.1-0.1,0.1-0.2,0.2-0.4c0.1-0.2,0.3-0.5,0.5-0.9c0.3-0.5,0.6-1.2,0.9-2.1c0.8-1.9,1.7-4.4,2.4-7.4 c0.1-0.4,0.2-0.8,0.3-1.3c0.2-0.8,0.3-1.7,0.5-2.6c0.8-5.4,1.4-10.8,1.8-14.5c1.9,0.9,3.7,2.1,5.6,3.2c2.5,1.4,5.2,1.9,7.8,3.1 c2.4,1.2,4.2,3,5.7,5.1c0.1,1.3,0.1,2.5,0.3,3.6c0.9,6.2,1,13.5,0.9,18.5l0,0C283.9,169.4,283.8,171.7,283.7,172.1z",
    style: {
      fill: "rgb(255, 213, 67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M266.3,176.6c-1-0.5-3.7-1.9-6.2-3.6c-0.1-0.1-0.3-0.2-0.4-0.3c-0.8-0.5-1.6-1.1-2.2-1.7 c-0.1-0.1-0.3-0.2-0.4-0.3c-0.4-0.3-0.7-0.7-1-1c-2.6-2.9-8.4-4.1-8.4-4.1l5-3.5l4-0.5c0,0,2.2,2.3,3.1,4.4 c0.5,1,1.1,1.8,1.7,2.7c0.1,0.1,0.2,0.2,0.2,0.3c0.4,0.6,0.9,1.2,1.2,2c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0.2,0.2,0.5,0.3,0.7 C264.6,174.9,267.9,177.4,266.3,176.6z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.7,160.3c0,0.9-0.8,7.3-1.4,11.1c-0.3,1.7-0.5,2.8-0.7,2.8l-15.8-2.2l-4.4-0.6c0,0,2.7-5.3,1.9-15.5 c-0.5-5.8-1.4-10.8-3.7-16.2c0,0,19.6,0.7,20,0.9c0.3,0.2,2,2.3,3,5.7c0.1,0.5,0.3,0.9,0.3,1.4c0.4,1.9,0.6,3.8,0.7,5.7 c0.1,1.7,0.2,3.5,0.1,5.2C187.7,159.2,187.7,159.7,187.7,160.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M187.7,158.6c0-1.7,0-3.5-0.1-5.2c-0.4,0.6-0.8,1.1-1.2,1.7c-1.4,2.1-3.9,1.3-5.9,2.6 c-1.2,0.7-2.2,1.7-2.7,3c-0.6,1.4-0.8,3-1.4,4.4c-1.2,3-2.9,5.6-6,6.7c-0.2,0.1-0.5,0.2-0.7,0.3l15.8,2.2c0.2,0,0.4-1.2,0.7-2.8 c0.6-3.8,1.4-10.2,1.4-11.1C187.7,159.7,187.7,159.2,187.7,158.6z",
    style: {
      fill: "rgb(176, 238, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M191.4,160.6c-0.3-0.5-1-1.7-1.7-2.3c-0.5-0.5-1.2-0.8-1.7-1.3c-0.3-0.2-1.3-1-1.6-0.5 c-0.1,0.1-0.1,0.2,0,0.3c0.1,0.3,0.6,0.6,0.7,0.7c0.2,0.2,0.7,0.6,0.7,0.9c0,0,0.2,0.8,0.1,1.2c0.1,0.9,0,1.9-0.3,2.7 c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.3,0.2,0.6,0.2,0.9c0.2,0.1,0.4,0.1,0.6,0.2c0.1,0,0.3,0,0.4,0c0,0,0.1,0,0.1,0 c0.2-0.1,0.4-0.2,0.7-0.4c0.5-0.6,1.9-2.5,1.9-2.5S191.4,160.7,191.4,160.6z",
    style: {
      fill: "rgb(255, 161, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M315.3,220.4c0,0-4.2,4.1-10.2,9c-11.4,9.5-29,22.3-35.2,16.3c-7.3-7.1-8.2-30.1-8.2-30.1 s13.4-2.8,19.8-6.2c6.4-3.3,11.6-9.1,11.6-9.1s4.1,5.6,8.5,10.4c2.4,2.6,4.9,4.9,6.8,6C314,219.8,315.3,220.4,315.3,220.4z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M334.9,253.1c-11.3-16.5-40.4-28.8-40.4-28.8s-23.7,7.1-23.9,8.8c-0.2,1.8,0.6,13.6,0.6,13.6 s8.2,5.2,28.4,11.9c10,3.3,12.4,4.7,12.4,4.7s-3.7,11.6-5.3,20.3c-0.4,0.9-0.9,1.7-1.2,2.7c-0.6,1.6-1.1,3.3-1.2,5 c-0.1,2.1,0.5,4.4-0.7,6.3c-0.8,1.2-2.2,2-2.5,3.5c-0.1,0.5,0,0.9,0.1,1.4c0.2,1.2-1.1,3.8-1.9,4.8c-1.1,1.6,15.9,7.5,15.9,7.5 S341,261.9,334.9,253.1z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M369.8,238.1c-0.4-1-1.6-1.1-2.5-0.9c-1.7,0.3-3.2,1.4-4.9,1.7c-1,0.2-2-0.1-3,0.1 c1.6,1.3,2.9,2.3,2.9,2.3s0,2.6-0.4,5.8c0.8-0.4,1.4-1.2,2-1.9c0.5-0.7,0.8-1.5,1.3-2.2c0.7-1.1,1.6-1.5,2.8-2.1 C368.8,240.4,370.3,239.5,369.8,238.1z",
    style: {
      fill: "rgb(20, 18, 40)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M315.3,220.4c0,0-4.2,4.1-10.2,9c-0.9-0.6-5.9-4.2-6.4-5.3c-0.6-1.2,1.6-2.4,2-4.6c0.3-2.2-1.8-2.5-0.6-4.3 c0.8-1.2,1.2-3.1,1.5-4.3c2.4,2.6,4.9,4.9,6.8,6C314,219.8,315.3,220.4,315.3,220.4z",
    style: {
      fill: "rgb(30, 23, 33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.6,160.8c-0.3-0.5-0.2-0.8-0.1-1.3c0.1-0.2,0.2-0.4,0.2-0.7c0-0.2-0.1-0.4-0.2-0.6 c-0.2-0.4-0.2-0.8,0-1.3c0.2-0.4-0.5-0.6-0.7-0.2c-0.2,0.3-0.4,0.7-0.3,1.1c0,0.4,0.5,0.7,0.5,1.1c0,0.4-0.4,0.8-0.4,1.2 c0,0.4,0.2,0.7,0.4,1.1C245.2,161.5,245.8,161.2,245.6,160.8z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M261.8,169c-0.4,0.5-0.9,1-1.6,1.3c-0.9,0.4-1.8,0.6-2.7,0.7c-0.1-0.1-0.3-0.2-0.4-0.3 c0.9-0.1,1.9-0.3,2.9-0.7c0.7-0.3,1.2-0.7,1.6-1.2C261.6,168.8,261.7,168.9,261.8,169z",
    style: {
      fill: "rgb(255, 213, 67)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M263.2,171.4c-0.4,0.4-0.9,0.7-1.5,1c-0.5,0.2-1,0.4-1.6,0.5c-0.1-0.1-0.3-0.2-0.4-0.3 c0.6-0.1,1.3-0.3,1.8-0.6c0.7-0.3,1.1-0.7,1.5-1.1C263.1,171.2,263.1,171.3,263.2,171.4z",
    style: {
      fill: "rgb(255, 213, 67)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M562.8,48.6c-0.3,0.3-0.6,0.6-1.1,1c-0.5-0.9-1.2-1.7-1.9-2.5c-0.4-0.5-0.8-0.9-1.1-1.4 c0.4-0.2,0.7-0.4,1-0.6c0.1-0.1,0.2-0.1,0.3-0.2c0.3,0.3,0.6,0.7,0.8,1c0.3,0.5,0.7,0.9,1,1.4C562.2,47.7,562.5,48.2,562.8,48.6 z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M268,101.9c-0.5,0.3-1.1,0.6-2,0.7c-0.3,0-0.6,0.1-0.9,0c-0.9,0-1.5-0.3-1.9-0.6c0-0.1,0-0.3,0-0.4 c0.5,0.3,1.4,0.8,2.8,0.6c0.9-0.1,1.5-0.4,2-0.7C267.9,101.6,268,101.8,268,101.9z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M268.3,102.9c-0.4,0.3-1.1,0.7-2.1,0.9c-0.9,0.2-1.8,0.3-2.6,0.2c-0.2,0-0.3,0-0.5,0c0-0.1,0-0.2,0-0.4 c0.7,0.1,1.8,0.1,3-0.2c1-0.2,1.7-0.6,2.1-1C268.2,102.6,268.2,102.8,268.3,102.9z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,103.9c-0.5,0-0.8-0.4-0.8-0.9c0-0.5,0.4-0.8,0.9-0.8c0.5,0,0.8,0.4,0.8,0.9 C265.2,103.6,264.8,104,264.3,103.9z M264.4,102.6c-0.3,0-0.5,0.2-0.5,0.4c0,0.3,0.2,0.5,0.4,0.5c0.3,0,0.5-0.2,0.5-0.4 C264.8,102.9,264.6,102.7,264.4,102.6z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.1,193.7c-0.8-1-0.8-2.9-2.3-3.2c-0.8-0.1-1.3,0.5-1.8,0.9c-0.3,0.2-0.6,0.4-0.9,0.4 c-0.4,0-0.9-0.3-1.3,0c-0.4,0.3-0.4,0.9-0.6,1.2c-0.2,0.5-0.6,0.9-1,1.3c-0.3,0.2-0.9,0.6-0.9,1.1c-0.1,1,0.7,0.8,1.3,0.9 c2.4,0.4,1.5,1.2,1.8,2.9c0.1,0.4,0.1,0.8,0.5,1c0.8,0.4,1.6-0.4,1.9-1.1c0.2-0.3,0.2-0.8,0.3-1.1c0.5-1,1-0.7,1.8-1 c0.5-0.1,1-0.4,1.4-0.8C258.4,195.3,257.9,194.7,257.1,193.7z M255.5,195.3c-0.4,0.4-0.9,0.7-1.4,1c-0.4,0.3-0.9,0.6-1.4,0.7 c-0.3,0.1-0.7-0.1-0.7-0.4c0-0.2,0-0.6-0.2-0.7c-0.1-0.2-0.4-0.2-0.5-0.3c-0.3-0.2-0.5-0.5-0.6-0.8c-0.2-0.7,0.4-1.1,1-1.2 c0.3-0.1,0.6-0.1,0.8-0.3c0.3-0.2,0.5-0.4,0.8-0.6C254.8,191.9,256.5,194.1,255.5,195.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.1,167.7c-0.8-1-0.8-2.9-2.3-3.2c-0.8-0.1-1.3,0.5-1.8,0.9c-0.3,0.2-0.6,0.4-0.9,0.4 c-0.8,0.1-1-0.3-1.6,0.4c-0.4,0.5-0.7,1.5-1,2.1c-0.3,0.7-0.3,1.6,0.3,2.1c0.3,0.2,0.8,0.3,1.1,0.6c0.2,0.2,0.3,0.5,0.5,0.7 c1,1.6,3.3-0.2,4.4-0.5c0.5-0.1,1-0.4,1.4-0.8C277.4,169.3,276.9,168.7,276.1,167.7z M274.5,169.4c-0.4,0.4-0.9,0.7-1.4,1 c-0.4,0.3-1.7,1.2-2,0.3c-0.1-0.2-0.1-0.5-0.2-0.7c-0.2-0.3-0.6-0.4-0.8-0.6c-0.3-0.2-0.4-0.7-0.3-1c0.2-0.9,1.3-0.6,1.9-1.1 c0.3-0.2,0.5-0.4,0.8-0.6C273.8,165.9,275.5,168.2,274.5,169.4z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267,145.5c1,0.9,1.2,2.8,2.8,2.8c0.8,0,1.2-0.7,1.7-1.2c0.2-0.3,0.5-0.5,0.8-0.6c0.4-0.1,0.9,0.2,1.3-0.2 c0.3-0.3,0.3-0.9,0.4-1.3c0.1-0.5,0.4-1,0.8-1.4c0.3-0.3,0.8-0.8,0.7-1.2c-0.1-1-0.8-0.7-1.4-0.7c-2.4,0-1.7-0.9-2.3-2.5 c-0.1-0.3-0.3-0.8-0.6-0.9c-0.8-0.3-1.5,0.7-1.7,1.3c-0.1,0.4,0,0.8-0.1,1.1c-0.4,1.1-0.9,0.9-1.6,1.2c-0.5,0.2-0.9,0.6-1.3,1 C265.4,144.1,266,144.6,267,145.5z M268.3,143.6c0.3-0.5,0.8-0.9,1.2-1.2c0.4-0.3,0.8-0.7,1.3-0.9c0.3-0.1,0.7,0,0.8,0.3 c0.1,0.2,0.1,0.5,0.3,0.7c0.2,0.1,0.4,0.1,0.6,0.2c0.3,0.1,0.6,0.4,0.7,0.7c0.3,0.7-0.3,1.1-0.8,1.4c-0.3,0.1-0.6,0.2-0.8,0.4 c-0.2,0.2-0.4,0.5-0.7,0.7C269.5,146.9,267.5,145,268.3,143.6z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275,206.1c1,0.9,1.2,2.8,2.8,2.8c0.8,0,1.2-0.7,1.7-1.2c0.2-0.3,0.5-0.5,0.8-0.6c0.4-0.1,0.9,0.2,1.3-0.2 c0.3-0.3,0.3-0.9,0.4-1.3c0.1-0.5,0.4-1,0.8-1.4c0.3-0.3,0.8-0.8,0.7-1.2c-0.1-1-0.8-0.7-1.4-0.7c-2.4,0-1.7-0.9-2.3-2.5 c-0.1-0.3-0.3-0.8-0.6-0.9c-0.8-0.3-1.5,0.7-1.7,1.3c-0.1,0.4,0,0.8-0.1,1.1c-0.4,1.1-0.9,0.9-1.6,1.2c-0.5,0.2-0.9,0.6-1.3,1 C273.5,204.7,274.1,205.2,275,206.1z M276.4,204.2c0.3-0.5,0.8-0.9,1.2-1.2c0.4-0.3,0.8-0.7,1.3-0.9c0.3-0.1,0.7,0,0.8,0.3 c0.1,0.2,0.1,0.5,0.3,0.7c0.2,0.1,0.4,0.1,0.6,0.2c0.3,0.1,0.6,0.4,0.7,0.7c0.3,0.7-0.3,1.1-0.8,1.4c-0.3,0.1-0.6,0.2-0.8,0.4 c-0.2,0.2-0.4,0.5-0.7,0.7C277.6,207.5,275.5,205.6,276.4,204.2z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.8,179.2c-0.2-1.7-2.6-1.6-3.5-2.6c-1.1-1-2.1-2.4-3.9-1.6c-0.7,0.3-0.8,0.9-1.2,1.4 c-0.2,0.3-0.7,0.5-0.9,0.8c-0.3,0.4-0.5,0.9-0.5,1.4c-0.1,1,0.1,1.4,0.5,2.3c0.4,0.9,0.3,1.6,0.3,2.5c0,0.5-0.3,0.6-0.1,1.1 c0.3,1.1,1.7,1.1,2.7,1c1.6-0.1,2.6-1,3.6-2.3c0.5-0.7,0.9-1.2,1.6-1.7c0.3-0.2,0.6-0.3,0.8-0.6 C253.5,180.5,253.9,179.9,253.8,179.2z M250.6,181c-0.8,0.6-1.3,1.2-1.9,1.9c-0.4,0.5-1.1,1.3-1.8,1.1c-1.1-0.3-1.4-2.8-1.5-3.8 c-0.2-1.4,0-3.1,1.7-3.1c0.8-0.2,1.8,0,2.6,0.4C251.2,178.5,252.6,179.6,250.6,181z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.3,156.7c0.5,1.6,2.8,1.1,4,1.8c1.3,0.8,2.6,1.9,4.1,0.8c0.6-0.5,0.6-1,0.9-1.7c0.2-0.4,0.6-0.6,0.8-1 c0.2-0.4,0.3-1,0.3-1.5c0-1-0.4-1.4-1-2.1c-0.6-0.8-0.7-1.5-0.8-2.4c-0.1-0.5,0.2-0.6-0.1-1.1c-0.5-1-1.9-0.7-2.8-0.5 c-1.6,0.4-2.4,1.5-3.1,3c-0.4,0.8-0.7,1.4-1.2,2c-0.2,0.3-0.5,0.4-0.7,0.7C273.3,155.4,273.1,156.1,273.3,156.7z M276.1,154.4 c0.6-0.7,1-1.4,1.5-2.2c0.3-0.5,0.8-1.5,1.6-1.4c1.2,0,1.9,2.5,2.3,3.4c0.5,1.3,0.6,3-1.1,3.3c-0.8,0.4-1.8,0.4-2.6,0.1 C276,156.9,274.5,156.2,276.1,154.4z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.3,172.8c-0.4-0.5-1-0.7-1.6-0.9c-0.8-0.3-1.4-0.7-2.1-1.2c-0.2-0.1-0.3-0.3-0.5-0.5 c-1.2-0.8-2.4,0-3.5,0.5c-0.9,0.4-1.5,0.7-1.5,1.8c0,0.7,0.6,1.3,0.9,1.9c0.7,1.2,0.5,2,0.6,3.3c0.2,2.2,3.3,2.7,4,0.5 c0.3-1,0.3-1.9,1.3-2.4c0.6-0.3,1.2-0.5,1.8-0.9C232.4,174.3,232.9,173.6,232.3,172.8z M229.9,173.8c0,0.1-0.1,0.1-0.1,0.2 c-0.4,0.5-1.2,0.3-1.6,0.8c-0.4,0.5-0.4,1.4-0.8,2c-0.6,0.8-1.5,0.2-1.5-0.6c0-0.4,0.2-0.8,0.2-1.2c-0.1-0.8-1-1.3-1.1-2.2 c-0.1-2.1,3.2-1.2,4.1-0.5C229.6,172.6,230.1,173.3,229.9,173.8z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.7,181.5c0.4,0.5,1,0.6,1.6,0.8c0.9,0.2,1.4,0.6,2.1,1.1c0.2,0.1,0.3,0.3,0.5,0.4 c1.3,0.7,2.4-0.2,3.5-0.7c0.9-0.4,1.5-0.8,1.4-1.9c-0.1-0.7-0.6-1.3-1-1.9c-0.7-1.1-0.6-2-0.7-3.2c-0.3-2.2-3.4-2.5-4-0.3 c-0.3,1-0.2,1.9-1.2,2.5c-0.6,0.4-1.2,0.5-1.7,1C276.5,179.9,276.1,180.7,276.7,181.5z M279.1,180.3c0-0.1,0-0.1,0.1-0.2 c0.3-0.6,1.2-0.3,1.6-0.9c0.4-0.5,0.3-1.4,0.6-2c0.5-0.8,1.4-0.3,1.5,0.5c0.1,0.4-0.2,0.8-0.1,1.2c0.1,0.8,1.1,1.2,1.2,2.1 c0.2,2.1-3.1,1.4-4.1,0.7C279.4,181.5,278.8,180.9,279.1,180.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.9,186.3c-0.5-0.3-1-0.5-1.4-0.7l0,0c-0.6-0.3-1.2-0.8-1.5-1.7c-0.2-0.5-0.3-1-0.7-1.4 c-1-0.8-2.6-0.5-3.5,0.4c-0.4,0.4-0.5,0.8-0.6,1.3c-0.1,0.7,0,1.2-0.5,1.7c-0.3,0.4-0.8,0.5-1.1,0.9c-0.2,0.3-0.2,0.6-0.2,0.9 c0,0.4,0.3,0.7,0.3,1.1c0.1,0.5-0.3,1-0.5,1.5c1.6,0.5,3.2,1,4.6,1.7c0.1,0,0.2,0.1,0.3,0.1c0.5-0.3,0.9-0.6,1.3-1 c1.3-1.2,3.2-0.1,4.2-1.3c0.1-0.2,0.2-0.4,0.3-0.6C239.5,187.9,239,186.9,237.9,186.3z M236.7,189c-0.9,0.3-2.1,0.2-2.5,0.2 c-0.2,0-0.4,0-0.5,0.1c-1.1,0.3-1.4,1.9-2.8,1.5c-0.8-0.3-1.1-1-0.9-1.8c0.3-1.2,1.2-2,1.3-3.2c-0.1-0.5-0.1-0.9,0.1-1.3 c0.4-0.5,0.9-0.9,1.6-0.7c1.1,0.4,1,1.9,1.9,2.5c0.7,0.4,1.9,0.4,2.4,1.1l0,0c0,0,0,0,0.1,0.1c0.1,0.1,0.2,0.3,0.2,0.4l0,0 C237.8,188.4,237.3,188.8,236.7,189z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M266.2,207.3c-1.3-0.7-2.4-0.8-2.9-2.4c-0.2-0.5-0.3-1-0.7-1.4c-1-0.8-2.6-0.5-3.5,0.4 c-0.3,0.4-0.5,0.8-0.6,1.3c-0.1,0.7,0,1.2-0.5,1.7c-0.3,0.4-0.8,0.5-1.1,0.9c-0.2,0.3-0.2,0.6-0.2,0.9c0,0.4,0.3,0.7,0.3,1.1 c0.1,0.7-0.6,1.3-0.6,2c0,1.2,1.7,1.7,2.6,1.8c1.5,0.2,2.6-0.5,3.7-1.5c1.5-1.3,3.6,0.3,4.5-1.9 C267.8,209,267.3,207.9,266.2,207.3z M265,210c-0.9,0.2-2.1,0.2-2.5,0.2c-0.2,0-0.4,0-0.5,0.1c-1.1,0.3-1.4,1.9-2.8,1.5 c-0.8-0.3-1.1-1-0.9-1.8c0.3-1.2,1.2-2,1.3-3.2c-0.1-0.5-0.1-0.9,0.1-1.3c0.4-0.5,0.9-0.9,1.6-0.7c1.1,0.4,1,1.9,1.9,2.5 c0.7,0.4,1.9,0.4,2.4,1.2C266.2,209.3,265.8,209.8,265,210z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.3,182.5c1,1.1,2,1.5,2,3.2c0,0.5-0.1,1,0.3,1.5c0.7,1,2.3,1.3,3.4,0.8c0.4-0.2,0.7-0.6,1-1 c0.3-0.6,0.4-1.1,1-1.5c0.4-0.3,0.9-0.2,1.3-0.5c0.3-0.2,0.4-0.5,0.5-0.8c0.1-0.4,0-0.8,0.1-1.1c0.2-0.7,1-1.1,1.2-1.7 c0.4-1.1-1-2.1-1.9-2.6c-1.4-0.7-2.6-0.3-4,0.2c-1.8,0.8-3.3-1.4-4.9,0.4C259.3,180.4,259.4,181.5,260.3,182.5z M262.3,180.3 c0.9,0,2,0.5,2.4,0.6c0.2,0.1,0.4,0.1,0.5,0.1c1.2,0,1.9-1.4,3.1-0.5c0.7,0.5,0.7,1.3,0.3,2c-0.7,1-1.8,1.5-2.3,2.6 c-0.1,0.5-0.2,0.9-0.6,1.2c-0.5,0.4-1.2,0.6-1.7,0.1c-0.9-0.7-0.3-2.1-1-3c-0.5-0.6-1.7-1-1.9-1.9 C260.9,180.6,261.5,180.3,262.3,180.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M265.8,162.2c-1.1,0.6-2.2,0.5-3.3-0.1c-0.8-0.5-1.4-0.7-2.3-0.9c-0.4,0-0.8,0-1.2-0.1 c-0.2-0.1-0.5-0.2-0.7-0.3c-0.2-0.1-0.3-0.2-0.4-0.4c0,0,0,0,0-0.1c0.3-0.5,0.6-1.2,0.9-2.1c0.5,0.1,1.1,0.1,1.6,0.2 c0.3,0.1,0.7,0.4,1.2,0.7c1.1,0.8,2.5,1.8,3,0.7c0.3-0.6,0-1.2-0.4-1.8c-0.3-0.6-0.7-1.3-0.6-2c0.2-1.1,1.1-1.9,0.6-3.1 c-0.5-1-1.7-1.8-2.9-2.2c0.1-0.4,0.2-0.8,0.3-1.3c1.5,0.3,3.2,0.3,3.8,0.6c1.2,0.6,1.6,2,1.3,3.3c-0.2,1-0.9,1.9-1.1,3 c-0.1,0.4,0,0.8,0,1.1c0.2,0.9,0.9,1.3,1.3,2.2C267.3,160.7,266.7,161.7,265.8,162.2z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.6,198.5c-1.6,0.2-3.3,0.6-4,0.5c-1.4-0.2-2.1-1.5-2.2-2.8c-0.1-1.1,0.3-2.1,0.2-3.1 c-0.2-1.7-1.4-1.8-2.2-2.8c-0.7-0.9-0.4-1.9,0.3-2.7c0.9-0.9,2-1.1,3.2-0.8c0.7,0.2,1.2,0.3,1.8,0.2c0.3,1,0.6,1.9,0.8,2.6 c-1.2-0.3-3.8-1.7-4.1-0.2c-0.2,1.2,1.8,2,2,3.4c0.1,1.1-0.5,2.2,0.3,3.1c0.8,0.9,2.3,1.3,3.7,1.2 C293.6,197.7,293.6,198.1,293.6,198.5z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.7,189.1c-0.1-0.2-0.2-0.5-0.4-0.7c-0.6-0.8-2.4-1.4-3.4-1.6c-1.5-0.3-3-0.2-4.1,0.9 c-1.5,1.5-1.7,4.2-4.1,4.5c-1.3,0.2-3.3-0.4-4.2,0.8c-0.4,0.5-0.4,0.9-0.2,1.4c0.2,0.5,0.7,0.9,0.9,1.3c0.3,0.8,0,1.4-0.2,2.1 c-0.7,2.6,1.9,5,4,2.8c0.6-0.6,1.1-1.3,2-1.4c0.4,0,0.9,0.1,1.4,0.1c0.8-0.1,1.5-0.4,2.2-0.9c0.8-0.5,1.4-1.2,1.9-2 c0.6-1,0.7-2.1,1.3-3c0.7-1.1,2-1.6,2.6-2.8C279.8,190.2,279.9,189.7,279.7,189.1z M277.2,190.3c-0.2,0.5-0.7,1-1.1,1.5 c-1.2,1.4-1.5,3.6-3.1,4.6c-0.2,0.1-0.4,0.2-0.7,0.2c-0.8,0.4-1.7,0.6-2.5,1.2c-1,0.6-1.8,1.8-3.1,1.6c-0.7-0.1-1-0.6-1.1-1.3 c-0.1-0.7-0.2-1.4-0.2-2.1c0.1-1.8,1.1-2.3,2.7-2.7c1.1-0.2,1.9-0.3,2.6-1.2c0.4-0.4,0.6-1,0.9-1.5c0.6-1,1.5-1.9,2.6-2.4 c0.7-0.3,1.5-0.2,2.3,0.2C277.4,189.1,277.5,189.7,277.2,190.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 182.6,
    cy: 169.8,
    r: 1.3,
    style: {
      fill: "rgb(176, 238, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M419.7,124.3c0,0-3.6,3.7-5.7,5.5c-1.5,1.4-3,2.3-3.9,2.8l-1.6-2.8L419.7,124.3z",
    style: {
      fill: "rgb(242, 128, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M444.9,165.3c-0.6,0.6-1.1,1.3-1.7,1.9c-0.5,0.5-1,1-1.5,1.4c-0.1,0-0.1,0.1-0.2,0.1 c-0.3-0.3-0.7-0.6-1.1-1c0.5-0.4,1.1-0.8,1.6-1.3c0.7-0.7,1.4-1.6,2-2.3C444.4,164.5,444.7,164.9,444.9,165.3z",
    style: {
      fill: "rgb(52, 46, 56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M444.1,166.6c0-0.7-0.5-1.3-1.2-1.3c-0.7,0-1.3,0.5-1.3,1.2c0,0.7,0.5,1.3,1.2,1.3 C443.5,167.8,444.1,167.2,444.1,166.6z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M245.4,149.3c-0.6-0.4-1.3,0.7-1.7,1.3c-0.4,0.6-1,1.8-0.8,2.1c0.1,0.2,0.5,0.2,0.8-0.3 c0.4-0.5,0.7-1,1.1-1.6C245.2,150.3,246,149.6,245.4,149.3z",
    style: {
      fill: "rgb(82, 40, 28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M249,145.5c-0.9,0.2-1.8,1.4-1.5,1.6c0.4,0.3,0.6,0,0.9-0.3c0.2-0.2,0.3-0.4,0.6-0.6 c0.3-0.1,0.8-0.1,0.8-0.5C249.8,145.4,249.5,145.4,249,145.5z",
    style: {
      fill: "rgb(82, 40, 28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M246.7,152.4c-0.2-0.1-0.6-0.1-0.8,0.2c-0.2,0.3,0,0.7,0.2,0.9c0.1,0.1,0.3,0.2,0.4,0.2 c0.1,0,0.2,0,0.2-0.1c0.5-0.2,0.5-0.8,0.1-1.1C246.8,152.5,246.8,152.4,246.7,152.4z",
    style: {
      fill: "rgb(38, 20, 20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M250.8,147.8c-0.2-0.1-0.6-0.1-0.7,0.2c-0.2,0.3,0,0.6,0.1,0.8c0.1,0.1,0.2,0.2,0.4,0.2 c0.1,0,0.1-0.1,0.2-0.1C251.2,148.6,251.2,148.1,250.8,147.8C250.9,147.8,250.8,147.8,250.8,147.8z",
    style: {
      fill: "rgb(38, 20, 20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M249.7,149.8c0.5,0.1,1.1,0.1,1.6,0.4c0.6,0.3,0.7,0.9,0.5,1.5c-0.1,0.2,0.2,0.3,0.3,0.1 c0.2-0.5,0.2-1.1-0.2-1.6c-0.5-0.6-1.4-0.7-2.1-0.8C249.6,149.5,249.5,149.8,249.7,149.8z",
    style: {
      fill: "rgb(196, 85, 71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M250.5,151.7c-0.2,0.3-0.4,0.7-0.4,1c0,0.2,0.3,0.2,0.3,0c0-0.3,0.1-0.6,0.3-0.8 C250.9,151.7,250.6,151.5,250.5,151.7z",
    style: {
      fill: "rgb(196, 85, 71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M254.9,151.7c0,0-0.6,1.1-1,1.7c-0.5,0.6-1,1.1-1.5,1.4c0.5,0.1,1.4-0.3,1.9-1 C255.1,152.7,254.9,151.7,254.9,151.7z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M348.9,104.4c0.5,0.2,1,1.1,0.4,1.4c-0.2,0.1-0.4,0.2-0.6,0.2c-0.3,0.1-0.5,0.3-0.7,0.5 c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.3,0-0.4,0c-0.9-0.4-0.6-1.8,0.1-2.1C347.7,104.4,348.3,104.3,348.9,104.4L348.9,104.4z",
    style: {
      fill: "rgb(30, 23, 33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M340.6,108.6c0.4-0.7,0.9-1.3,1.6-1.7c0.9-0.6,2.5-0.1,2.2,1c-0.1,0.2-0.2,0.4-0.4,0.5 c-0.2,0.1-0.3,0.2-0.5,0.3c-0.4,0.1-0.8,0.3-1.1,0.5c-0.3,0.2-0.5,0.4-0.8,0.5C340.9,110.2,340.3,109.2,340.6,108.6L340.6,108.6 z",
    style: {
      fill: "rgb(30, 23, 33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M344.3,109.9c0.2,0.2,0.3,0.5,0.4,0.8c0.1,0.4-0.1,1-0.6,0.9c-0.3-0.1-0.6-0.3-0.8-0.5 c-0.2-0.2-0.4-0.5-0.4-0.8c-0.1-0.5,0.1-1.1,0.8-1C343.9,109.4,344.1,109.6,344.3,109.9z",
    style: {
      fill: "rgb(26, 5, 4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M349.7,107.2c0.2,0.2,0.3,0.5,0.3,0.8c0.1,0.4,0,1-0.5,0.9c-0.3-0.1-0.5-0.3-0.7-0.5 c-0.2-0.2-0.3-0.5-0.4-0.8c-0.1-0.5,0.1-1.1,0.6-0.9C349.3,106.7,349.5,106.9,349.7,107.2z",
    style: {
      fill: "rgb(26, 5, 4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M348.9,111.2c-0.1,0.2-0.4,0.1-0.3-0.1c0.3-0.5,0.6-1.2,0.1-1.7c-0.3-0.2-0.6-0.4-1-0.5 c-0.2-0.1-0.1-0.4,0.1-0.3c0.4,0.3,1,0.4,1.3,0.9C349.5,110,349.2,110.7,348.9,111.2z",
    style: {
      fill: "rgb(120, 60, 48)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M348.1,110.5C348.1,110.5,348.2,110.5,348.1,110.5c0.1,0.1,0.1,0.2,0.1,0.2c0,0-0.1,0.1-0.1,0.1 c-0.2,0.1-0.4,0.2-0.5,0.4c-0.2,0.2-0.4-0.1-0.3-0.2c0.2-0.2,0.4-0.4,0.7-0.5C348,110.5,348,110.5,348.1,110.5z",
    style: {
      fill: "rgb(120, 60, 48)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M351,112.4c0.1,0.4,0.1,0.7,0,1.1c-0.3,0.7-1.4,1.3-2.1,1.3c-0.7,0.1-1.9-0.1-2.5-0.5 c-0.5-0.4-0.2-0.8,0.3-1c1.2-0.5,2.4-1.2,3.6-1.9c0.2-0.1,0.3-0.1,0.5,0.1C350.9,111.7,351,112.1,351,112.4z",
    style: {
      fill: "rgb(204, 90, 82)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.4,114.3c-0.5-0.4-0.2-0.8,0.3-1c1.2-0.5,2.3-1.1,3.4-1.8c0.1,0.2,0.1,0.3,0.1,0.5 c0,0.2-0.1,0.4-0.2,0.5c-0.4,0.4-0.8,0.8-1.3,1.1C348,113.9,347.2,114.2,346.4,114.3L346.4,114.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M498.2,62.5c-0.1,0.2-0.1,0.5,0,0.7c0.1,0.2,0.3,0.4,0.5,0.5c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1 c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.1-0.2c0.1-0.2,0.1-0.4,0-0.6c-0.1-0.2-0.2-0.4-0.4-0.5c-0.3-0.2-0.9-0.3-1.1,0.1 C498.3,62.3,498.2,62.4,498.2,62.5z",
    style: {
      fill: "rgb(26, 5, 4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M504.3,61.1c-0.1,0.2-0.1,0.5,0,0.7c0.1,0.2,0.3,0.4,0.5,0.5c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1 c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.1-0.2c0.1-0.2,0.1-0.4,0-0.6c-0.1-0.2-0.2-0.4-0.4-0.5c-0.3-0.2-0.9-0.3-1.1,0.1 C504.3,60.9,504.3,61,504.3,61.1z",
    style: {
      fill: "rgb(26, 5, 4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M503.3,62.7c-0.2-0.2-0.5,0.2-0.2,0.4c0.3,0.2,0.6,0.5,0.7,0.9c0.1,0.4-0.3,0.8-0.5,1c0,0-0.1,0.1-0.1,0.1 c0,0.1,0,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1s0.1,0,0.2,0c0.2-0.2,0.4-0.4,0.5-0.6c0.1-0.2,0.2-0.5,0.2-0.8 C504.1,63.4,503.8,62.9,503.3,62.7L503.3,62.7z",
    style: {
      fill: "rgb(102, 40, 27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M496.2,60.9c0.1,0.4,1.4-0.2,2.3-0.4c0.5-0.1,1.1,0,1.2-0.3c0.1-0.2,0.1-0.3,0.1-0.5 c-0.1-0.6-1-0.3-1.5-0.2c-0.5,0-1,0.2-1.4,0.5l-0.1,0.1C496.3,60.5,496.1,60.4,496.2,60.9z",
    style: {
      fill: "rgb(150, 73, 57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M503.7,59.6c0.3-0.1,0.6-0.2,0.9-0.2c0.3,0,0.6-0.1,0.9,0c0.3,0,0.9-0.2,1-0.5c0.1-0.5-0.4-0.2-0.8-0.4 c-0.4-0.3-1-0.4-1.5-0.3c-0.6,0.1-2.2,0.8-1.6,1.3C502.9,59.7,503.1,59.7,503.7,59.6z",
    style: {
      fill: "rgb(150, 73, 57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M502.6,64.3c-0.3,0.1-0.6,0.2-0.8,0.4c-0.2,0.2,0.1,0.5,0.3,0.3c0.2-0.1,0.4-0.2,0.6-0.3 C503,64.7,502.9,64.3,502.6,64.3z",
    style: {
      fill: "rgb(102, 40, 27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M501,67.8c0,0.1-0.1,0.1-0.1,0.2s0,0.1,0.1,0.2c0,0.1,0.1,0.1,0.2,0.1c1.5,0.1,3.2,0.4,4.5-0.5 c0.3-0.2-0.1-0.6-0.4-0.4c-1.1,0.8-2.8,0.5-4.1,0.4C501.1,67.7,501,67.8,501,67.8z",
    style: {
      fill: "rgb(102, 40, 27)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M433.1,80.4c-0.5-0.3-1.1-0.3-1.6-0.2c-0.2,0.1-0.4,0.2-0.7,0.3c-0.1,0.1-0.3,0.1-0.4,0.2 c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.2,0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3,0c0.5-0.2,1-0.3,1.5-0.3 c0.2,0,0.5,0.1,0.7-0.2C433.7,80.4,433.5,80.6,433.1,80.4z",
    style: {
      fill: "rgb(150, 73, 57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M427,80.9c-0.5,0.1-1,0.3-1.5,0.6c-0.4,0.3-0.7,0.6-0.9,1c-0.1,0.1-0.2-0.6-0.2-0.4c0,0.2,0.1,0.3,0.2,0.4 c0.1,0.1,0.3,0.2,0.5,0.1c0.2,0,0.3-0.1,0.5-0.2c0.5-0.4,1.2-0.6,1.8-0.6c0.4,0,0.9-0.1,1-0.5C428.6,80.8,427.7,80.8,427,80.9z",
    style: {
      fill: "rgb(150, 73, 57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M432.2,82.3c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.3,0,0.7,0.2,1c0.2,0.3,0.7,0.5,1,0.2 C433.4,83.6,433.1,82.1,432.2,82.3z",
    style: {
      fill: "rgb(26, 5, 4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M427,83.4c-0.1,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.3-0.1,0.7,0.2,1 c0.2,0.3,0.7,0.5,1.1,0.2C428.3,84.7,428,83.2,427,83.4z",
    style: {
      fill: "rgb(26, 5, 4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M431,84.8c0.4,0.2,0.8,0.4,0.9,0.8c0,0.2,0,0.4-0.1,0.6c-0.1,0.2-0.2,0.4-0.4,0.5c-0.2,0.1,0,0.5,0.2,0.4 c0.2-0.2,0.4-0.4,0.6-0.6c0.1-0.2,0.2-0.5,0.2-0.8c0-0.7-0.6-1-1.1-1.3C431,84.3,430.7,84.6,431,84.8z",
    style: {
      fill: "rgb(196, 85, 71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M430,87c0.3-0.2,0.6-0.3,0.9-0.4c0.3-0.1,0.2-0.5-0.1-0.4c-0.4,0-0.8,0.2-1.1,0.4 C429.5,86.9,429.8,87.2,430,87z",
    style: {
      fill: "rgb(196, 85, 71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432.9,88.5c0-0.1,0-0.1-0.1-0.2c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0l-1.5,0.3 c-0.4,0-0.8,0.2-1.1,0.4c-0.1,0.1-0.2,0.2-0.1,0.3c0.4,0.4,1.6,0.5,2.4,0.2C432.8,89,432.9,88.6,432.9,88.5z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "matrix(0.062824, 0, 0, 0.064615, 33.649479, 410.01767)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M471.74,500.76v101.6H450.26V500.76Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M488.35,602.36V589.61l50.7-71.14h-50.8V500.76H566v12.75l-50.75,71.14h50.85v17.71Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "matrix(0.062824, 0, 0, 0.064615, 33.649479, 410.01767)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M803.7,718.29c-2.74,17.08-131.28,22.82-142.92,21.6,25-8.27,70.71-16.77,90.26-34.23a6.38,6.38,0,0,0-2.21-10.78,203.72,203.72,0,0,0-38.07-8.94q-9.21-1.25-18.69-1.65-2.48,2.57-5,5a160.9,160.9,0,0,1-78.8,47.51h0a161.43,161.43,0,0,1-40.2,5.06,159.69,159.69,0,0,1-17.31-.93c-1.31-.13-2.62-.29-3.92-.46-2.61-.34-5.2-.75-7.77-1.21,1.69-.18,3.37-.38,5-.61,1.25-.17,2.49-.35,3.73-.54,27.68-4.26,62.65-24.48,85.89-45a166.58,166.58,0,0,0,44.55-95.86,105.5,105.5,0,0,1-60.81,60.3c-2.93,1.12-5.91,2.11-9,3a104.64,104.64,0,0,1-20.31,3.6,89.43,89.43,0,0,0,57-50.29c.45-.79.9-1.58,1.34-2.37A44.64,44.64,0,0,0,652,587.32v-.07c.28-2.86.42-5.77.42-8.71a89.15,89.15,0,0,0-1.9-18.39l-.12-2.15,22.32-5.5,4.31-1.06,7.93-2,5.85-1.44-2.07-9-9.1.34a5.23,5.23,0,0,1-5-3.19L665,513.33a7,7,0,0,1,6.44-9.72h19.34A4.36,4.36,0,0,1,695,507l9.17,37.81,16.65-4.1c.34-2.88.59-5.66.74-8.37,2.26-38.11-12.39-59.84-25.62-85.82a204.59,204.59,0,0,0-19.71-31.3,203.62,203.62,0,0,1,15,14.42c27.63,29.44,49.42,64,55.78,105.77q1.43,9.38,2,19,.35,6,.35,12c0,31.41-10.38,63-23,89.62,16.76,7.58,35.62,15.49,49.6,27.09,11.3,9.38,16.52,13.08,23.21,21.42C802.76,709.09,804.63,712.52,803.7,718.29Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3",
    transform: "matrix(0.062824, 0, 0, 0.064615, 33.649479, 410.01767)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M536.91,215.84c16.82-4.06,71.63,112.35,75,123.56-17.26-19.89-42.71-58.79-66.36-70.1a6.37,6.37,0,0,0-9.09,6.19,204.07,204.07,0,0,0,6.41,38.58c1.6,6,3.49,12,5.68,17.88,2.21.86,4.41,1.77,6.59,2.7a160.91,160.91,0,0,1,74.2,54.42l0,0a161.58,161.58,0,0,1,20.15,35.15,159.81,159.81,0,0,1,5.81,16.33c.39,1.26.74,2.53,1.09,3.79q1,3.81,1.87,7.64c-.81-1.49-1.65-3-2.5-4.42-.64-1.09-1.28-2.16-1.94-3.23-14.59-23.9-46.72-48.39-74.6-61.93a166.55,166.55,0,0,0-105.62-4.19q5.28-.12,10.52.28a106.05,106.05,0,0,1,68.55,32.61q3.24,3.41,6.18,7.13A104.94,104.94,0,0,1,570,435.63a89.45,89.45,0,0,0-68.39-33.28l-2.7-.32a44.66,44.66,0,0,0-24.45,4.22l-.07,0c-2.74.84-5.48,1.84-8.2,3A89,89,0,0,0,450,418.09L448,419l-13.68-18.47L431.72,397l-4.85-6.57-3.58-4.84L415.74,391l3.82,8.27a5.23,5.23,0,0,1-1,5.85l-17.36,17.71a7,7,0,0,1-11.44-2.2l-7.45-17.85a4.37,4.37,0,0,1,1.45-5.21l31.35-23-10.19-13.78c-2.79.79-5.45,1.63-8,2.54-36,12.6-50.45,34.49-69.33,56.7a205.13,205.13,0,0,0-21.29,30.25,203,203,0,0,1,7.54-19.36c16.53-36.84,40-70.26,76.12-92.22q8.1-4.94,16.79-9.16c3.57-1.75,7.23-3.4,10.95-5,29-12.1,62.16-14.71,91.58-13.27.53-18.38.57-38.83,5.89-56.2,4.3-14,5.7-20.29,10.82-29.67C528.78,220.25,531.23,217.2,536.91,215.84Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4",
    transform: "matrix(0.062824, 0, 0, 0.064615, 33.649479, 410.01767)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.46,703c-12.19-12.27,58.85-119.55,66.69-128.24-8,25.08-28.08,67-25.47,93.11a6.37,6.37,0,0,0,10,4.56A203.71,203.71,0,0,0,278.33,647q6.44-6.72,12.34-14.14-.62-3.51-1.11-7a160.86,160.86,0,0,1,8-91.67.05.05,0,0,1,0,0,161.65,161.65,0,0,1,19.58-35.48,158.1,158.1,0,0,1,10.94-13.44c.88-1,1.78-1.95,2.68-2.9,1.81-1.91,3.67-3.76,5.55-5.57-.85,1.48-1.67,2.95-2.47,4.44-.6,1.11-1.18,2.21-1.76,3.33-12.85,24.88-17.1,65.05-14.2,95.91a166.58,166.58,0,0,0,51.25,92.45q-2.85-4.45-5.23-9.14a106,106,0,0,1-7.71-75.51c.82-3,1.78-6,2.89-9a104.39,104.39,0,0,1,9-18.54,89.4,89.4,0,0,0,7.07,75.73c.37.83.74,1.66,1.12,2.48a44.72,44.72,0,0,0,16.3,18.7l.06,0q3.22,2.86,6.79,5.47a89.32,89.32,0,0,0,16,9.29l1.81,1.17-8.7,21.28-1.68,4.11-3.09,7.55L401.52,712l8.52,3.65,5.09-7.56a5.24,5.24,0,0,1,5.53-2.17l24.14,5.64a7,7,0,0,1,4.06,10.93l-11.39,15.63a4.37,4.37,0,0,1-5.2,1.47l-36-14.85-6.49,15.87c2.13,2,4.23,3.81,6.33,5.53,29.48,24.26,55.67,25.21,84.46,29.81a204.07,204.07,0,0,0,36.9,2.5,202.69,202.69,0,0,1-20.46,3.6c-40.07,5-80.82,2.27-118.34-17.18q-8.41-4.38-16.55-9.59-5-3.22-9.91-6.79C326.86,730,307.41,703,293.38,677.13c-16,9.09-33.5,19.67-51.1,24.14-14.24,3.62-20.3,5.66-31,6.15C205.45,707.68,201.58,707.18,197.46,703Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientOnboardImg);
export default __webpack_public_path__ + "static/media/ClientOnboardImg.fdb0f8229208e015d276a6999b1a72e6.svg";
export { ForwardRef as ReactComponent };